import React, { useEffect, useState } from 'react';
import './binakontrast.css';

const BinaKontrast = () => {
  const [toc, setToc] = useState([]);
  const [tocOpen, setTocOpen] = useState(false);


//   useEffect(() => {
//     // שלב 1: מוסיף מזהה אוטומטי לכל h2/h3 אם אין להם id
//     document.querySelectorAll('h2, h3').forEach((el, index) => {
//       if (!el.id) {
//         el.id = `section-${index}`;
//       }
//     });

//     // שלב 2: יוצר רשימת קישורים מתוכן הכותרות
//     const items = Array.from(document.querySelectorAll('h2, h3')).map((el) => ({
//       id: el.id,
//       text: el.textContent,
//       level: el.tagName.toLowerCase(),
//     }));

//     setToc(items);

//     // שלב 3: מוסיף חץ חזרה להערות שוליים
//     document.querySelectorAll('[id^="footnote-"]').forEach((el) => {
//       if (!el.querySelector('.back-link')) {
//         const backLink = document.createElement('a');
//         backLink.textContent = ' ↩ ';
//         backLink.href = 'javascript:history.back()';
//         backLink.className = 'back-link';
//         el.appendChild(backLink);
//       }
//     });
//     // ✅ השאר רק את זה:
// // document.querySelectorAll('h2').forEach((el) => {
// //   if (!el.nextElementSibling?.classList?.contains('play-btn')) {
// //     const btn = document.createElement('button');
// //     btn.textContent = '🔊';
// //     btn.className = 'play-btn';
// //     btn.title = 'השמע את הפסקאות עד הכותרת הבאה';
// //     btn.onclick = () => {
// //       let text = '';
// //       let next = el.nextElementSibling;
// //       while (next && !['H2', 'H3'].includes(next.tagName)) {
// //         text += next.innerText + '\n';
// //         next = next.nextElementSibling;
// //       }
// //       const msg = new SpeechSynthesisUtterance(text);
// //       msg.lang = 'he-IL';
// //       speechSynthesis.speak(msg);
// //     };
// //     el.insertAdjacentElement('afterend', btn);
// //   }
// // });


//   }, []);



useEffect(() => {
  // שלב 1: מזהה אוטומטית את כל הכותרות
  document.querySelectorAll('h2, h3').forEach((el, index) => {
    if (!el.id) el.id = `section-${index}`;
  });

  // שלב 2: יוצר תוכן עניינים
  const items = Array.from(document.querySelectorAll('h2, h3')).map((el) => ({
    id: el.id,
    text: el.textContent,
    level: el.tagName.toLowerCase(),
  }));
  setToc(items);

  // שלב 3: מוסיף קישורי חזרה להערות שוליים
  document.querySelectorAll('[id^="footnote-"]').forEach((el) => {
    if (!el.querySelector('.back-link')) {
      const backLink = document.createElement('a');
      backLink.textContent = ' ↩';
      backLink.href = 'javascript:history.back()';
      backLink.className = 'back-link';
      el.appendChild(backLink);
    }
  });

  // שלב 4: כפתור השמעה רק לכותרות h2, לא כולל את הכפתור עצמו בקריאה
  document.querySelectorAll('h2').forEach((el) => {
    if (!el.parentElement.classList.contains('h2-wrapper')) {
      // עוטף את הכותרת ואת הכפתור באותה שורה
      const wrapper = document.createElement('div');
      wrapper.className = 'h2-wrapper';
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);

      const btn = document.createElement('button');
      btn.textContent = '🔊';
      btn.className = 'play-btn';
      btn.title = 'השמע את הפרק עד הכותרת הבאה';
      wrapper.appendChild(btn);

      let isPlaying = false;
      let utterance = null;

      btn.onclick = () => {
        if (isPlaying) {
          speechSynthesis.cancel();
          isPlaying = false;
          btn.textContent = '🔊';
          document.querySelectorAll('.reading-now').forEach((p) => p.classList.remove('reading-now'));
          return;
        }

        // מתחיל *מהאלמנט אחרי wrapper (לא אחרי הכפתור)* ועד הכותרת הבאה
        let text = '';
        let next = wrapper.nextElementSibling;
        const paragraphs = [];

        while (next && next.tagName !== 'H2') {
          if (next.innerText?.trim()) {
            text += next.innerText + '\n';
            paragraphs.push(next);
          }
          next = next.nextElementSibling;
        }

        if (!text.trim()) return;

        utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'he-IL';

        // הדגשה בזמן קריאה
        utterance.onboundary = (event) => {
          const charIndex = event.charIndex;
          let total = 0;
          for (let i = 0; i < paragraphs.length; i++) {
            total += paragraphs[i].innerText.length;
            if (charIndex < total) {
              paragraphs.forEach((p) => p.classList.remove('reading-now'));
              paragraphs[i].classList.add('reading-now');
              break;
            }
          }
        };

        utterance.onend = () => {
          isPlaying = false;
          btn.textContent = '🔊';
          paragraphs.forEach((p) => p.classList.remove('reading-now'));
        };

        btn.textContent = '⏹️';
        isPlaying = true;
        speechSynthesis.speak(utterance);
      };
    }
  });
}, []);

  return (
    <div
      className="bina-kontrast"
      style={{
        direction: 'rtl',
        whiteSpace: 'pre-line',
        fontFamily: 'FrankRuehl, sans-serif',
        padding: '20px',
      }}
    >
      <p>
        קונטרס הבינה
      </p>
      
      <p>
        אשמח להערות והארות
      </p>
      <p>
        באימייל : bina@motto.co.il
      </p>
      <p>
        
        או בטלפון: 0795157670<br />
      </p>
      <hr />
      <h3
  style={{ cursor: 'pointer', userSelect: 'none', marginBottom: '8px' }}
  onClick={() => setTocOpen((v) => !v)}
>
  תוכן העניינים {tocOpen ? '▲' : '▼'}
</h3>

{tocOpen && (
  <ul>
    {toc.map((item) => (
      <li key={item.id} style={{ marginRight: item.level === 'h3' ? '20px' : '0' }}>
        <a href={`#${item.id}`}>{item.text}</a>
      </li>
    ))}
  </ul>
)}


      <hr />
 

 <h2>הקדמה</h2>
      <p>
אחד הפיתוחים הטכנולוגיים המרשימים ביותר של השנים האחרונות הינו תחום הבינה המלאכותית.
</p>
      <p>
גילוי זה מוטמע היום כמעט בכל מערכת מתקדמת, הן בגלוי והם תחומי הצאטים (שבינתיים  chatgpt של  openai מוביל אך גם המתחרים לו מראים ביצועים די יפים), נציגי שרות דיגיטליים ועוד, והן במוטמע כפיתוחי מכוניות אוטונומיות, מערכות ניתוח נתונים ועוד.
</p>
      <p>
הרעיון הטכנולוגי שלו כנראה כבר הוגה לפני כ 70 שנה, אך לא היתה עדיין הטכנולוגיה המספקת לפתחו מחד והן עוד נדרש לו אז הרבה מחקר.
</p>
      <p>
אבל ביסוד הדברים הרעיון הוא די בסיסי והוא שמערכת שבנויה בשרשרת (או רשת) ונכוון את המעבד הראשון לחקות דפוס  להשוואה מקסימלית לדפוס התנהגות או זיהוי מסויים, על פי מספר רב של מקרים נתונים<a href="#footnote-1">[1]</a> ואחר כך נכוון את המשך השרשרת באופן זה, בריבוי מספיק של מעבדים, התגובה למקרה חדש תהיה קרובה לתגובות ראשונות<a href="#footnote-2">[2]</a>- תהליך זה נקרא כיוונון או אימון.
</p>
      <p>
התאוריה הוכחה כמוצלחת לא רק לדמות תגובת ניהול שיחה אנושית, אלא גם בתחומים שונים של פיתוח לוגי, הדמיה רגשית, זיהוי מגדרי, זיהוי ויצירת תמונות, הדמית תגובות בעלי חיים, ביצוע פעולות פיזיות ועוד.
</p>
      <p>
כבר קיימים מערכות שמפתחות קוד תכנות בעצמם או שבונות תכנון עיצוב לבית מחד<a href="#footnote-3">[3]</a> וכן מערכות שיכולות להגיב בצורה המדמה רגשות בקול אנושי מתלהב או עצוב, יכולה לזהות ולצחוק מבדיחה וכדומה.
</p>
      <p>
המערכת היא אומנם רק מערכת מחשבים ואין לה באמת רגשות אבל היא מדמה אותם בצורה שדומה מאוד לתגובה אנושית, היא לא באמת "מבינה" אבל היא אכן יוצרת תוצר בהתאם לדרישה.
</p>
      <p>
מכיוון שמדובר על מערכת שבעצם מהותה היא מחקה תגובות אנושיות, אין מניעה שהמערכת הזאת גם תנהל מערכות אחרות באם היא תכוונן על ידי מספר מספק של התנהגויות של מנהלים, וכן אין מניעה שהמערכת גם תפעיל מערכות אחרות, באם היא תפותח באופן זה.
</p>
      <p>
ולדעתי כל אלו , אם לא שכבר קיימים, עתידים להיות ממש בשנים הקרובות.

 </p>
      

<h3>הקדמה מיותרת  </h3> 

ברור לי שיש אנשים שמסתכלים בפיתוחים מתוך חוסר ראיית התהליכים הפנימיים המתהווים ומתוך כך מגיעים למסקנה של כוחי ועוצם ידי ומובילה אותם לספקות באמונה שגם ככה לא היתה מוחלטת בדעתם, בדברי אלו אני לא מתכוון לעסוק בזה בכלל לא בלהוכיח ולא בלדחות דעות אלו ואחרות ולכן כל הקדמה זו מיותרת, כוונתי בדברים אלו הוא רק לנסות להתבונן בתהליכים שלדעתי יובילו להתרוממות בהכרתו של האדם, וממילא מתוך כך להמשך בניין תיקון עולם במלכותו , מחד, וקצת לעורר, מאידך, על סכנות אמוניות – חינוכיות<a href="#footnote-4">[4]</a>, שכרוכים בעקבם של תהליכים אלו<a href="#footnote-5">[5]</a><a href="#footnote-6">[6]</a>.

<h3> מבוא</h3>
      <p>
את התהליך הטכנולוגי של הבינה המלאכותית, הסברנו בקצרה בהקדמה, אבל עם הופעה של טכנולוגיה זו, היא גרמה "סערה" בגישות ביחס אליה.<br/>

תוך כ 3 חודשים מעת הופעת chatgpt  היו לו כבר כמאה מליון משתמשים.<br/>

היו שטענו שהטכנולוגיה הזו תחליף את רוב תחומי העבודה הקיימים היום, והיו שטענו שהיא תשמש רק ככלי עזר לתחומי העבודה השונים ותפתח אותם, היו שטענו שהיא תהיה כלי משחית ביד אירגוני טרור והיו שטענו ....<br/>

וכיוון שלדעתי כולם צודקים כאן אבל ועם זאת השפעתה לדעתי תהיה גדולה הרבה יותר מכל הנ"ל אנסה להתיחס במאמר זה בקצרה אל השינויים וההשפעות הטכניות שלדעתי יהיו לטכנולוגיה זו, ובמיוחד במקום שיש לשינוי טכני זה השפעה מוסרית או תודעתית.<br/>

<h3>אמצעי ומטרה  </h3>
עוד להוסיף , שכל ארוע וכל פיתוח , מגיע בעיתו ממי שאמר והיה  העולם, וכשם שברור הוא  שכל פיתוח חומרי או רוחני, וכל גילוי מדעי לא יגיע לפני שהעולם יהיה מוכן וראוי לקבלו, לפני שמדרגתו המוסרית של האדם ראויה לו, כן ברור הוא, שהוא כן יגיע בזמן בו העולם יהיה ראוי לקבלו, שמדרגתו המוסרית של האדם ראויה לו.<br/>
ובזה כל גילוי ופיתוח הוא כלי לעילויו החומרי של האדם, הראוי לו בהתאם למדרגתו המוסרית.<br/>
<br/>
אבל יתרה מזו, לדעתי , כל הופעה חומרית, כל תהליך חומרי או רוחני, פרטי או כללי, הוא לא רק נגרר מהמדרגה הרוחנית של האדם אלא הוא גם מכין אותה לעילויה, וכשהאדם ראוי למדרגה חדשה, הרי כל האמצעיים החומריים והחברתיים הנדרשים בשביל להוביל את האדם למדרגה זו יופיעו, והרי המציאות החומרית, מבחינה זו, היא מובילה את האדם לעלייתו המוסרית. ובמבט מלמטה למעלה , הרי היא, העלייה החומרית,  קודמת להתרוממות המוסרית ומובילה אותה, ובמבט פנימי יותר, ההכשרה של האדם להתרומם למדרגה רוחנית חדשה, מחייבת היא, מסדרי המציאות הפנימיים, להוביל את כל האמצעיים החיצוניים להופעת מדרגה זו, והרי היא, ההתרוממות המוסרית, קודמת להופעת האמצעיים הנדרשים לה , ומנביעה אותם, בחינה של תורה קדמה לעולם.<br/>
<br/>
וכיוון שידי קצרה לי מלהביט ולרדת לעומקם של המגמות הא-לקיות המופיעות עלינו לטובה, אני אנסה להביט דווקא באותו מבט חיצוני , ראשוני, על התהליכים החיצוניים ולנסות לראות מתוכם תהליכים שעלולים לבא לנו בגינם, ואם נכוון לתורת אמת, ממילא נדע גם לצפות בתהליך הפנימי המנביע את הופעות ההאמצעיים החומריים.<br/>
<br/>
 </p>
      <p>

ואני תפילה שיהיו דברי מכוונים לאמיתתם של התהליכים בהם מוליך אותנו מי שאמר והיה העולם ומשלים זה הבניין.
</p>
      
 

<h2>פרק א - ברור תכלית האדם</h2>
<h3>משל המחרשה והחץ</h3>
<p>
לפני כ 23423*xyz שנים, בימים בהם המקצועות המבוקשים התמקדו ביכולות הניצוח הפיזי.<br/>

כל אימא פולניה ממוצעת איחלה לבן שלה לפחות חגורה שחורה בקארטה.<br/>

המשכורות הגבוהות התמקדו ביכולת השימוש בחרבות.<br/>

ובקורות החיים מי שלא מנה את מספר הראשים שערף היה נחשב לגמרי ללא נסיון.<br/>

אמת, היתה איזה מועקה פנימית שנשמעה לפעמים על המוסריות שבחיים אלו.<br/>

אבל ההכרח לא יגונה (או שכן..) ואלו שיכלו לכלכל את חייהם בצורה נוחה ונעימה עם הכרח האלימות ויכולת ההתגברות הפיזית היו מושא עיניהם ותכלית השלמות של כל המחפשים את הצד היותר נוצץ בחיים.<br/>

עד שחל המהפך, המצאת החץ.<br/>

האינטרנט געש, אם גם מי שאין כוחו בידיו יוכל לפגוע באנשים, מה תכליתו של האדם?<br/>

חושבי מחשבות וצופי שחורות הזהירו מפני החשש שכל אחד יוכל לקחת חץ וקשת בידיו ולהרוג ולהשמיד את האנושות כולה (מה שלא ממש התבדא במהלך השנים).<br/>

העיתונות בערה, אנשים הסתובבו כמוכי הלם.<br/>

ההמצאה החדשה אומנם  הביאה בקרבה הרג רב מחד ופיתוחים נטולי משמעות מאידך, אבל גם הובילה לשינוי תודעתי שלא בכוחו הפיזי של האדם תכליתו, לא בנצחונו בקרב מעלתו ולא בהרג יתפאר.<br/>

התהפכו היוצרות.<br/>
</p>
      <p>
התהליך אומנם לקח זמן אבל הביא עימו שינוי עצום.<br/>
</p>
      <p>
אחרי<a href="#footnote-7">[7]</a> החרב והחץ , הגיע המחרשה והעגלה גלגל המיים והמטחנה, ומשם החשמל והמכונית.<br/>

אנשים עם יכולות פיזיות גבוהות ולוגיות נמוכות, כבר פחות נדרשים במרחב התעסוקתי, דווקא מי שיש לו כישורי חשיבה וניתוח, יוכל למצא את עצמו בתחום העשירון העליון בתחומי התעסוקה, לא זנחנו את הפיתוח החומרי אבל הוא הפך להיות, אצל רוב האנשים כמשני ולא כעיקרו של האדם, אבל יותר מכל אלו הוא השינוי התודעתי , עליונים למטה ולתחתונים למעלה, הציור האנושי של בעל הכח כפסגה האנושית התהפך,<br/>

התרבות האנושית החלה להחשיב יותר ויותר את המשכילים , את בעלי הידע ויכולת החשיבה והניתוח.<br/>

לימודי החול הפכו  הכרחיים לרוב מקצועות העבודה ובהחלט העלו משמעותית את התפוקה היצרנית.<br/>

כל אימא פולניה ממוצעת איחלה לבן שלה לפחות תואר ראשון אם לא פרופסורה.<br/>

המשכורות הגבוהות התמקדו ביכולת השימוש והפיתוח המדעי.<br/>

ובקורות החיים מי שלא מנה את שנות לימודיו, פשוט לא היה נחשב.<br/>

אנשים החלו להתפאר בידיעותיהם, קיבלו תאורי כבוד של דוקטור או פרופסור, את הילדים חינכו מגיל 0 על הצורך בלימודים, התרבות הכללית משקיעה בילד את רוב שעות ערנותו ללימודים, מקומות העבודה מעדיפים "משכילים"  אגם שזה לא תחום הקשור לעבודה, על פני חסרי השכלה.<br/>

הכרח התעסוקתי – קיומי של ההשכלה הפך אותה להיות מהכרח תעסוקתי להכרח תודעתי, לתבנית שלמות האדם, אם במוצהר ואם שלא.<br/>

וזוהי נטייה אנושית טבעית להחשיב את מה שאנו עוסקים בו רוב זמננו ואת המכשירים להכרח קיומנו לבעל ערך.<br/>

 </p>
      <p>

אמת, שיש עדיין איזה מועקה פנימית שנשמעה לפעמים הן מצד הילדים שלא תמיד ששו להקריב את חייהם על מזבח המדע, עד שלמדו שכן ראוי הוא.<br/>
</p>
      <p>
והן מצד הטוענים שיש בהתמסרות ללימודים איזה צימצום לכוחות החיים שבאדם, מחקרים טענו שילד עד שמתחיל להשקיע את מירב זמנו בלימודים צוחק מאות פעמים ביום, ועם כניסתו ללימודים הדבר יורד בהדרגה לעשרות בודדות או פחות.
</p>
      <p>
והן מצד הטוענים כי ההתמסרות למדע מצמצמת את מוסריותו , אנשים שעסוקים במדע תדיר , לפעמים לא ישימו לב אם הם עסוקים בפיתוח מכשירים להרע.
</p>
      <p>
(נ"ב: אני לא נגד לימודים, מקווה שעוד אדבר בזה בהמשך)
</p>
      <p>
אבל ההכרח לא יגונה (או שכן..<a href="#footnote-8">[8]</a>).
</p>
  <h3>לו יצוייר...</h3>
 <p>
אבל אם נצייר לעצמנו מציאות בו אין משמעות ובוודאי לא הכרח לפיתוח המדעי – טכנולוגי, לא לצורך מאמץ המלחמה, ולא לצורך תעסוקה, האם גם אז היינו מחשיבים את ההשכלה כתכלית האדם? כמעלתו ויתרונו על פני  כל חי?<br/>

לו יצוייר .....<br/>

מבחינה מדעית, החידוש הגדול של הבינה המלאכותית זה שהיא יכולה לא רק להפעיל כח אלא לחקות דפוסי חשיבה, כאמור, מערכות בינה מלאכותית כבר כיום יכולות לספק פיתוחים ברמה של דוקטורט, לחקור ולפתח חוקי מתמטיקה ופיזיקה חדשים ועוד.<br/>

לו יצוייר שבעוד שנים מועטות, כשנצטרך טיל חדש ללחימה נוכל לומר למערכת פתחי לי טיל עם יכולות כאלו וכאלו, והדבר יבוצע בתוך דקות וללא צורך בעשרות מדענים ומאות שעות פיתוח, מה הצורך שיהיה לנו בלמידה ארוכת טווח של המדעים הפיזיים הנצרכים לפיתוח הטיל.<br/>

יתרה מזאת אם נוכל לומר למערכת:  "יש עלינו איום כזה וכזה" , והיא כבר תחליט לבד אם לפתח טיל או לבנות טנק,  "הייתי רוצה גלידה שוקולד עם סוכריות" והיא כבר תפתח מכשיר ליצור זאת בעצמה, "אני צריך להגיע לחיפה, תפתח מערכת שתעביר אותי לשם בצורה הנוחה והקלה ביותר"<br/>

מה יהי בימים אלו תפקידם של לימודי המדעים? האם הם עדיין יהיו הכרח קיומי  ומתוך כך הכרח תודעתי או אולי...<br/>

האם מי שיגיע עם תעודת תואר שלישי-רביעי-חמישי בפיזיקה יחשב כבעל מעלה או כמי שיוכיח לנו מעבר לכל ספק שבמקום לבזבז את זמנו לשוא הוא השקיע אותו במאות אלפי תחרויות שש-בש....<br/>
</p>
<h3>עליה בהכרה האנושית</h3>

<p>
אבל השאלה שלנו היא לא מה לא יחשב למעלתו של האדם אלא מה כן יחשב למעלתו של האדם ולכן עדיין אנחנו צריכים לעסוק בשאלה "המותר האדם מן הסמארטפון?"

</p>
<p>
או יותר נכון, ברור שכן, זוהי תודעה אנושית פשוטה! אלא, עלינו להבין במה מותר האדם מן הסמארטפון (או הבינה המלאכותית)?<a href="#footnote-9">[9]</a>

</p>
<p>
ננסה לצייר לעצמנו באיזה מקומות לא תוכל הבינה המלאכותית להגיע או מה כן יהיה תפקידו של האדם, עם ואחרי פיתוח הבינה המלאכותית, בהמשך פיתוחו של עולמו של הבורא.

</p>
<p>
מתוך אותה הנחה שההכרח יוצר מציאות תודעתית, שלדעתי אינה רק בדמיונו של האדם, אלא היא גילוי תפקידו וממלא תכליתו של האדם, ננסה לדמיין איך יראה המרחב התעסוקתי בפרט(עבודה בשכר) או מרחב העיסוק בכלל, כדי לנסות לצייר את תודעת תכלית האדם ומעלתו.

</p>
<p>
אם כל פיתוח חומרי כבר יוכל להיווצר במערכות ממוכנות כולל מערכות הדורשים מחקר ופיתוח נוסף, אם המערכת תוכל לבנות ולחקור, ליצר ולפתח , מה יישאר לנו לעשות? רק לנתב את המערכות האלו לצורה מוסרית, עם כל מערכת רבת עוצמה ניתן להיטיב מחד או להרוג ולפגוע מאידך, אז אולי תפקידנו הוא להשגיח על המכונה ולכוון מעשיה במוסריות ואולי לשם תכליתו של האדם, בימים בהם ידרשו מיליוני עובדים כדי להשגיח על מערכות המתפתחות מעצמם , שיתפתחו בצורה מוסרית, ומי שרב לו במוסריותו ויוכל יותר להשגיח ויותר לכוון את ההתפתחות הנוצרת מתוך מערכות אלו, יהיה יותר נדרש, ממלא גם התודעה תתרומם להכרה שבמוסריותו של האדם- מעלתו.

</p>
<h3>
האומנם מעלת האדם במוסריותו?
</h3>
<p>
לכאורה היה מקום לומר שמעלת האדם במוסריותו, האדם יכול להיות נחמד\תורם\עוזר, לחוש בכאבו של הזולת ולהשתתף עימו וכדומה,  לעומת המכונה שאינה אלא מכונה ואינה עושה אלא מה שתאמר לה אינה אלא תכנית וללא רגשות וממלא לא תוכל להבחין בן תשובה מוסרית לתשובה שאינה מוסרית אלא שלדעתי תשובה זו עדיין צריכה ברור, ולצורך זה אני רוצה לשתף כאן עוד פיסת מידע הסטורי – עכשווי, המודל הקודם של chat gpt , אם הייתי מבקש ממנו שאלה בסגנון "חבר הבריז לי שוב, תעזור לי לנסח משפט בו אני מבהיר לו שאני שונא אותו ואיני מעוניין יותר בקשר עימו" הייתי מקבל תשובה לעיניין, אבל במודלים החדשים אני אקבל תשובה שתפתח בסגנון מְרַצֶּה שינסה להרגיע אותי ולא לגרום לי לומר דבר שאתחרט עליו אחרכך...

</p>
<p>
 כלומר גם בתחום זה של "מוסריות"<a href="#footnote-10">[10]</a> מערכת הבינה המלאכותית יכולה לחקות התנהגות אנושית, היא תדע "לכבד זקנים", "לשמח לב נדכאים" וכו' <a href="#footnote-11">[11]</a>.

</p>
<h3>
מהלכים בין העומדים
</h3>
<h3>
מוסר אובייקטיבי או סובייקטיבי
</h3>
<p>
אני מרגיש שלהמשיך מכאן , כבר ממש קצרה ידי, רק בתור הצעת דברים נראה לי שיש לחלק בן סוגים שונים של מוסר , ובין מוסר אובייקטיבי-סטאטי-עומד לבין מוסר מתחדש, או מוסר בעליה

</p>
<p>
המערכות של הבינה המלאכותית בנויות בצורה של הדפסה של דפוסי התנהגות, כלומר אם אני מכניס להם דפוס מסויים הרבה פעמים הם "יודעים" לחקות אותו אבל לא יודעים לייצר התנהגות מוסרית חדשה<a href="#footnote-12">[12]</a> <a href="#footnote-13">[13]</a> .

</p>
<h3>
תפקידנו בעלייה
</h3>
<p>
וכאן הייתי רוצה להעיר הערה, שלפי דעתי נכונה גם לגבי עבודתינו וגם לגבי המבט הנכון על ארועים בהיסטוריה, תפקידנו בעלייה לתיקון עולם , לא רק בגילוי מה זה התנהגות מוסרית אלא בהטמעה נפשית של מוסר.

</p>
<p>
כל נטיה שהיא הקיימת באדם יש לה הופעה אידיאלית נכונה או הופעה ברמות שונות של סטיה מדרך הישר, אלא שעם צורת הופעתה המקולקלת היא מטבעת את חותמה בציבור וביחיד, כל אדם עוד בטרם לידתו מקבל כבר את השפעתה של אותה הטבעה מקולקלת בזרימת הדם בהיותו עובר, וממשיך בכל רובדי ההרכה של התפתחותו בשלביה השונים, עד עומדו על דעתו בצורך בתיקונה, אלא שבשלב זה היא כבר מוטבעת בו לא כנטיה בודדת אלא כמערך נפשי שלם, באם נניח שיגיע אדם מסויים בגדלותו, להכרה שכלית של מה הצורה האידיאלית של אותה נטיה ספציפית וינסה להנהיג את אורחות חייו בדרך זו , הרי הוא שובר את אותו מכלול נפשי הנבנה בו והדבר יפגע במערך המידות והופעת הכוחות האחרים שבנפשו<a href="#footnote-14">[14]</a>, ומלבד שלא יוכל להתקיים, הרי הוא מקלקל וגורע, (ולא יוכל להמשך ולהקבע כדפוס במרחב הציבורי) ולא זה תפקידנו, אלא מתוך אותה נקודת מערך נפשי בה אנו נמצאים לרומם את עצמנו ומתוך כך את סביבתינו ואת הכלל כולו, התיקון הקטן אותו יוביל בנפשו, בעמלו הרב ובשבירת הדפוסים הישנים, באם יהיה תואם ליכולת המכלול הנפשי להכיל, על אף שיהי רחוק ופעוט מול תיקון אידיאלי לאותה המידה בה אנו עוסקים, הרי הוא מרומם את עצמו בתיקון בר עמידה, הבן שלו שירש את דפוסי התנהגותו (וכן הסביבה הסובבת אותו), כבר יבואו למלחמת התיקון שלהם בנקודה גבוהה יותר, וטהורה יותר וממילא אותם מסקנות, הדרכות שהיו לו כבר לא יוכלו להתאים לנפשם העדינה יותר, בזכותו, עד שאם ימשיך נכדו ונינו בתהליך תיקון זה, לא יוכל הנין  להבין את המוסריות שמהנהגותיו אלו, לא בהכרתו ולא בעוצמת התיקון שלו, והרי הוא בבחינת ננס על גבי ענק,  וכל שאיפותיו המוסריות בניות על גבי אותה מדרגה שטבע סב-סבו.

</p>
<p>
וכך העולם הולך ומתעלה וכל דור ודור מתחדשת מדרגה בהליכי הברור, הברורים של המדרגה הקודמת כבר לא רלוונטיים , אחר שהתעלנו למדרגה החדשה.

</p>
<p>
מערכות הבינה המלאכותית, לדעתי, יוכלו להנגיש בצורה יפה מאוד כל מדרגה מוסרית שתבנה, ומתוך כך גם לעזור למסתרכים מאחור להתרומם לאותה המעלה, אבל לא יוכלו ליצור עליה בשום אופן<a href="#footnote-15">[15]</a> .

</p>
<h3>
סגירת מעגל
</h3>
<p>
אם נמשיך מתוך הבנה זו, שתפקידו ויחודיותו של האדם בכלל והאדם מישראל בפרט, היא ביכולתו ליצור מוסר מתחדש-מתרומם ומתוך אותן הנחות יסוד בהם פתחנו, שבהתאם ליכולות היחודיות של האדם גם נבנת ההכרה האנושית, תגזר מכאן ההכרה האנושית בחשיבותו של תיקון עולם בעליותו המוסרית.

</p>
<h3>
לא סוף דבר
</h3>
<p>
אמת שיכולנו לצייר את הדברים גם בתחומים שונים או תהליכים שונים, כשאיפתו של האדם לקרבת א-לקים, בבערה הפנימית למוסר, או כמימוש הרצון הפנימי שלו ועוד, ולדעתי דברים אלו משלימים אחד את השני, אבל יותר מזה שלא באתי לחייב תהליך מסויים, אלא  כמעורר, ועין לא ראתה.
</p>
<h2>פרק ב- העליה טכנית ומדעית בהתאם לעליה המוסרית</h2>
<h3>המועקה כממתקת את חשבונות הלב</h3>

<p>
כל עליה מוסרית, מכשירה את יכולת האדם לקבל יותר שפע גשמי, ומאידך, בטרם עליתו לאותה מדרגה , הרי הוא זקוק לאותו חסרון גשמי על מנת למתק את קושי הלב, לא רק אעדר מהשפעה שאינה לפי מדרגתו אלא חסרון הראוי לו לפי חסרון מדרגתו, ובזה הוא עצמו בחינה של חסרון בעל תכלית, "בורא את הכל".

</p>
<p>
הקללה שנתקלל האדם בזעת אפיך , אין משמעותה רק שעם חסרון מדרגתו המוסרית , הרי הוא אינו ראוי לשפע שאינו מצריך את זעת האפיים ואם יקבלו, הרי הוא עלול לו לרעתו, אלא יותר מזה , זעת האפים , היא הממתקת ומכשירה את האדם לעדן את נפשו ובכך להכשיר אותו לעלות למדרגה עליונה יותר הראויה לו.
</p>
<p>
וכלל זה נכון גם לשאר המועקות המלוות את האדם, הן חרדת המלחמות, והן כל חסרון ומועקה המלווה את האדם , הרי היא מכשירה ומעדנת את רוחו למעלה גדולה יותר.
</p>
<p>
וממילא אחרי שנתעדנה נפשו מאותה המועקה, הרי אינו זקוק לה עוד וממילא ראויה היא שתעלם.
</p>




<h3>
המועקה שבלימודי החול
</h3>
<p>
לא סוד הוא שכל ילד בהתחילו את לימודיו שואל פעמים רבות למה הוא צריך את אותו הצימצום, ובצדק, הלימודים דורשים מאמץ שזר לילדים ולא רק לילדים, אז למה בכל זאת אנו מחייבים את הילדים במועקה זו?, שאלתי לא מתיחסת ללימודי  תורה אלא דווקא ללימודים כללים (לבנים, שלא בת"תים, ולבנות גם בציבורים הישיבתיים)?
</p>
<p>
התשובה המקובלת לומר היא שזה צורך הכרחי -  תעסוקתי, "לא תלמד, לא יהיה לך מקצוע, ממה תתפרנס?" ואמת יש בדבר והאב מצווה ללמדו אומנות וזה בכלל, אבל מבחינה תודעתית זו תשובה חלקית מאוד, אנו רואים בהשכלה צורך תרבותי ויש לזה שני בחינות, האחת היא תפיסת מעלת האדם בשכלו והשכלתו, וכבר דיברנו בזה, אבל יש בזה עוד בחינה והיא שדווקא המועקה, שממנה זועק הילד, היא ממתקת ומעדנת אותו, אנו רואים שהלימודים והקושי והצמצום שמחוייב בגינם, מעדנים את האדם, אנו מצפים שאדם שלמד הרבה יהיה יותר בעל יכולת שליטה, בעל עדינות, אין בזה כלל מוחלט המשווה את כל האנשים, ועוד שגם עם עדינות נפש זו , הוא יכול להיות מושחט מבפנים, אבל עדיין יש בזה בחינה של מועקה הממתקת את קושי עורפו של האדם.
</p>
<p>
ואנו רוצים בעידון זה, עם ההכרח של הלימודים אנו מקנים לילדינו את יכולת הצימצום, יכולת השליטה על הפרעות הפנימית שבקירבו.

</p>
<p>
ואם הלימודים הם הכרח, הרי זה כעדות שהאדם נדרש למועקה זו.

</p>
<h3>
המועקה כמצמצמת
</h3>
<p>
אמת שבמועקה, מלבד היתרון של עידון הנפש של האדם, יש גם חסרון והוא צימצום הכוחות שבאדם

</p>
<p>
מצמום הכוחות של האדם, הרי הוא כהכרח לתת לאדם את יכולת השליטה ואת יכולת ההשלטה השכלית על כוחותיו הפרעיים , אבל מצד עצמה הרי היא צמצום, והרי היא מקטינה. הילד , בטרם הכנסו למסגרת הלימודית, צוחק הרבה יותר פעמים , מאשר אחרי היותו בה.

</p>
<p>
והרי זו בחינה של הקטנה של הכלי העצמי שלנו.

</p>
<p>
לו יצוייר מצב בו כוחותיו של האדם מופיעים בצורה אידיאלית, שאיפותם לקודש, וזרימתם הטבעית הרי היא מגלה ומבטאת שאיפות אלו, הרי לא היה צריך את אותו הצימצום וההקטנה של כוחות החיים.

</p>
<h3>
לימודים לבנות
</h3>
<p>
לדעתי נכון הדבר כלומר החסרון שבמציאות זו, עוד יותר ביחס ללימודים לבנות, בהם הנטיות הפשוטות, ההרגשיות יותר טהורות מצד עצמן ויותר מחויבות מצד תפקידן בבניית הבית, ובגידול הילדים, ששם הנטיות ההרגשיות הפשוטות , חשובות שבעתיים.
</p>
<p>
עד שעצם ההשלטה השכלית על ההרגשית יש בה חסרון, מצד עצמה, עוד לפני החסרון שבצמצום כוחות החיים<a href="#footnote-16">[16]</a>.

</p>
<p>
עד שהחמירו חזל באישה הקוראת לארון הקודש ארון, הגם שיתכן שזהו תהליך ברור השכלי של האדם, אבל הוא ביטוי לירידה הנטיה הטבעית של רוממות הקודש.

</p>
<h3>
לימודי קודש לבנות

</h3>
<p>
ונכון הדבר לא רק ללימודי החול אלא גם ללימודי קודש ,שלכן, לדעתי , התוו לנו חזל את החסרון שבלימודי קודש לבנות, כאילו מלמדה טפלות" .

</p>
<p>
ומן הראוי היה שלא ילמדו הבנות כלל לימודי קודש אלא רק מה שהתוו לנו חזל והא תורה שבכתב , וההלכות המעשיות להן,

</p>
<p>
אלא שכאן אנו ניצבים בפני צורך נוסף שאחר שהן כן לומדות לימודי חול, מתוך ההכרח הנ"ל , עם כל החסרון שבזה, אי אפשר להשאיר את אמונתן באותה מדרגה של חוסר הברור, שאחר שלימודי החול כבר חורצות את אותה החלקה הטובה של הנטיה ההרגשית הטהורה, ה-לא מותנת בהתוויה השכלית, לא נוכל להשאיר את ההדרכה האמונית בנויה על הנטיה ההרגשית, אחר שזו נפגמה ואבדה את עוצמתה, לא מצד כבודם של לימודי האמונה שלא יפחתו מלימודי החול, לא תהיה כהנת כפונדקית, אלא מצד עצמה שאחר שהוחלשו הנטיות הטביות הפשוטות , לא יוכלו לעמוד עוד מול רוחות הסער של הדעות הזרות ואתגרי התקופה, אם לא יקבלו את סעד האמונה השכלית.

</p>
<p>
אבל כל זה הוא מצד ההכרח שאחר החסרון שבצימצום שבא בעקבות לימודי החול.

</p>
<h3>
מגמת הצימצום
</h3>
<p>
צמצום כוחות החיים זה שאנו עוסקים בו, תכלית לו, שאחר שחיפש האדם חשבונות ואיבד את ישרותו, הרי כוחותיו כשמופיעים בצורה מלאה ולא ישרה הרי הם הולכים ומתרחקים, ועל מנת לישר את אותם הנטיות הטבעיות שבאדם הוא זקוק לצימצום כוחות החיים ובאותה המידה שהם נתרחקו מישרותם, ככה נדרשים הם ליצמצום שיאפשר את ההשלטה השכלית עליהם,

</p>
<h3>
ביטול המועקה
</h3>
<p>
אלא שאף שצימצום זה מחוייב המציאות והרי הוא שלב בתהליך תיקון החשבונות שבלב האדם, מכל מקום חסרון הוא בשלמות הופעת החיים של האדם, וככל חסרון הרי הוא עתיד להתקן ,שככל שהאדם מברר את דרכו ומכוון את מעשיו יותר ויותר על פי אותה ישרות טבעית שביסוד בריאתו, והרי הוא מטביע בעצמו (בפרט ובאדם בכלל) את אותה הישרות הטבעית, הרי הוא פחות ופחות נדרש לאותו הצימצום, שככל שנטיותיו הטבעיות מופיעות יותר בטהרתם, הרי הם יכולות להופיע יותר במלא עוצמתן,

</p>
<p>
ומתוך כך, אותה המועקה שהיתה מחוייבת המציאות על מנת להכשיר את האדם, אחר שעשתה את תפקידה הרי היא אינה נצרכת עוד וממילא מחוייבת היא שתבטל .

</p>
<p>
ואותו העמל שבנה ביגיעו את הבניין החומרי , בנה במועקתו את ההכשר הנפשי להיות האדם ראוי להופעת המדרגה רוחנית שמתוך מעלתה ראויה היא להופעת הבניין החומרי.

</p>
<p>
וממילא אף בנידון דידן, גם הלימודים הכללים, אחר שימלאו את תכליתם במועקה המתלווה עימם, לעדן את האדם ולישרו, הרי אין המעוקה נצרכת עוד וממילא גם הם אינם נצרכים עוד ועתידים להתבטל.

</p>
<h3>
ציור תעסוקתי
</h3>
<p>
אני רוצה לסיום הפרק לצייר ציור של תחומי התעסוקה עתידיים , שלדעתי, הוא מסקנה כמעט ישירה של התפתחות הטכנולוגיה ולצורך זה אני מצרף כאן 3 תחומי פיתוח שונים,

</p>
<p>
לצורך זה אנסה לנתח את הדברים כעיוור המתבונן רק בתהליכים הטכנולוגיים המתרחשים , כאילו לא מובטחים אנו ולהסיק מהם ציור אפשרי שלדעתי הוא ממש בתהליכי התהוות<a href="#footnote-17">[17]</a>.

</p>
<p>
האחד הוא התחום המטבעות, כבר כיום את רוב הכסף שאנו מקבלים כמשכורת אנחנו לא רואים כמטבעות כלל, אנחנו עובדים, חשבון הבנק מושפע ומכח זה אנחנו יכולים לקבל סחורה במכולת, לא ראינו את השקל מרגע העבודה ועד שאכלנו אותו כשמנת במטבח, ועוד יותר הדבר מקבל משמעות בתחום המטבעות הדיגיטלים.

</p>
<p>
ותחום נוסף הוא תחומי זיהוי גלים במוח (ממשקי מח – מחשב המזהים אותות מהמוח), מחקרים כבר הצליחו לזהות בצורה על קווית גלים במוח באופן שניתן להפעיל מערכות בלי צורך בדיבור או במגע פיזי , אלא רק על ידי מחשבה בלבד, תחום זה נמצא אומנם עדיין בשלבי מחקר ופיתוח מוקדמים ומשמש בשלב זה בעיקר כנסיון לפתח כלים לאנשים חסרי יכולת הנעת האברים (תסמונת הנעילה).

</p>
<p>
והאחרון  שכבר אנו עוסקים בו, הוא התפתחות הבינה המלאכותית , כיום מערכות הבינה יכולות לספר תוצרים ברמה של לימודי דוקטורט, לפתח משפטים מתמטיים  חדשים ובכלל זה גם לבצע פעולות מסויימות (רובוטיקה),

</p>
<p>
תחום זה האחרון מוביל אותנו לציור בו אין צורך בשכירת פועלים לצורך בניה ופיתוח אלא לצורך ניווט והכוונה מוסרית של מציאות מתחדשת, כלומר האדם ידרש לצורך מעלתו המוסרית ויכולת הפיתוח המוסרי-אמוני  שלו.

</p>
<p>
חיבור של שלושת התחומים הנל לדעתי מוביל לציור בו האדם יושב וחושב מחשבות מוסריות , וכפי רמת מוסריותו או יכולתו לחדש ציורי מוסר , טוהר וקדושה בדעתו בלבד , כפי טהרת ונקיון רצונותיו ודעותיו, כך נעשה רצונו<a href="#footnote-18">[18]</a> ובלי צורך להביע או להגשים את מחשבותיו ופיתוחים פיזיים בידיו או בפיו.

</p>
<p>
בהתאם לטוהר מחשבתו<a href="#footnote-19">[19]</a> כך, וכך בלבד תשואת משכורתו ויכולת המימוש שלה.

</p>
 

<h2>
פרק ג – שבירת הכלים
</h2>
<h3>
לימודי חול בימנו
</h3>
<p>
אלא שכאן יש לשאול, אחרי שהסקנו שכל לימודי החול הם מועקה העתידה להתבטל, ואנו רואים בעינינו את הבניין החומרי המכשיר מציאות זו, כלומר את בנייתם של מערכות בינה מלאכותית שיכולות לעשות במקומנו את הצורך הנדרש לבניין החומרי, בהשכלה החילונית, עם העדות להכשרו של האדם למדרגה זו מתוך ההכרה שכל מדרגה חומרית מופיעה רק עם הכשרותו של האדם לה

</p>
<p>
אולי לא נכון להכריח את ילדינו בלימודים המעשיים?

</p>
<p>
אין אני יודע לתת תשובה לזה, אבל יש כמה דגשים שלדעתי חושב לברר בבואנו לשאלה זו

</p>
<h3>
תקופת המעבר ושבירת הכלים
</h3>
<p>
בכל הופעה של מדרגה חדשה יש שלב ביניים שלב בו כבר מתחיל להתעורר בנפשות הצורך לאותה המדרגה מחד ומאידך אין הכלים עדיין מסוגלים להכיל את המדרגה ההיא שלב זה יוצר בטבעו תהליך של הכשרת הכלים לאותה המדרגה העליונה אלא שתהליך זה עלול הוא מאוד לשבירת הכלים<a href="#footnote-20">[20]</a>, חוסר מוכנות זו של הכלים להכיל את המדרגה הגדולה נובע משני תהליכים מנוגדים האחד הוא קטנות האדם ושיעבודו לתפיסות הישנות עליהם גדל והשני הוא הצורך האמיתי שעדיין קיים, אותו צורך שבנה במועקתו את ההכשר למדרגה הבאה, אותה הטהרה שנוצרת מתוך המועקה, שאינו נעלם ביום והוא עדיין קיים כצורך בתקופת מעבר<a href="#footnote-21">[21]</a>,  שאין הנפשות מטוהרות דיין שלא יצטרכו כלל את אותה המועקה וכבר התעלו מההכרח הגורף לה

</p>
<p>
אם עד ימינו אנו יכלנו להגדיר לבנינו את הצורך בלימודי החול כהכרח תעסוקתי, אף שבליבנו ראינו בו גם כלי חינוכי לעידון הנפש, לדעתי הטענה של צורך מעשי, מהר מאוד תימאס בלב הבנים<a href="#footnote-22">[22]</a>, עם העצמה של הדחיה הנפשית של המועקה שעדיין נדרשת אלא שהולכת ונהית פחות הכרחית מצד העידון הנפשי.

</p>
<p>
ולכן לדעתי ברור דברים אלו, עם הענווה הנדרשת להכשרתינו למדרגה זו,  יתן לנו את הכלים לבאר לעצמינו ולילדינו את מקומם הראוי של לימודי החול<a href="#footnote-23">[23]</a>

</p>
<h3>
סכנות בהעברת המסורת
</h3>
<p>
כיוון שעסקנו כאן בשבירת הכלים, אני רוצה להעיר על עוד סכנה שלדעתי היא בכלל שבירת הכלים וקשורה בתהליכים אלו

</p>
<p>
נתבונן על תהליך ההתרחקות שבתקופת ההשכלה,

</p>
<p>
הרבה צעירים משכילים שבעקב חוכמתם המדעית – טכנולוגית, הרגישו חכמים הרבה יותר מהדור הקודם, ממילא ראו את חוכמתם של אנשי הדור הקודם להם כבטלה לחוכמתם, וממילא נטשו את דרך ישראל סבא שקטנה בעיניים<a href="#footnote-24">[24]</a>

</p>
<p>
לדעתי עלינו להיות מודעים שמבחינה טכנולוגית, גם בדורינו אנו עלולים לאותה הסכנה,

</p>
<p>
אם נתפאר בפני בניינו בידיעותינו לפתח קרני ליזר או בפתרון משוואות מסובכות במטמטיקה, הרי אנו, בימים בהם חוכמות אלו יהיה נחלתם של מכונות החוכמה המלאכותית, עלולים למצוא את עצמינו כמי שהתפאר ביכולתו לסחוב בידיו 30 שקי מלט, מול בעל המשאית

</p>
<p>
סביר מאוד להניח שחוכמות החול שאנו למדנו, יקבלו משמעות שונה מאוד ומצומצמת מאוד, מחד ומאידך יתפתחו כלים חדשים במהירות גדולה, שהילדים שלנו יסתגלו להם הרבה יותר בקלות מאיתנו , וממילא אנו באותה סכנה של פער גדול בין הדורות שעלול לגרום לנתישה והתרחקות ח"ו

</p>
<p>
גם כאן לדעתי, ככל שחוזקינו בחינוכינו בנוי יותר על אדני האמונה, ככל שאנו רואים באמונת אומן את עיקר חיינו ומנחילים הכרה זו לבינייינו, הרי שהשינויים הטכנולוגיים העלולים הם רק האמצעיים ולא עיקר חיינו וממילא הסכנה שבניתוק דור הבנים קטנה, ומאידך, ככל שאו רואים את אותם כלים, וידיעות והשכלות כעיקרים יותר בחיינו , הרי אנו יותר עלולים למצא את עצמינו במצב בו עיקר חיינו אינו אלא גליונות בדפי ההסטוריה של בנינו וממילא הסכנה שהתרחקות בנינו מדרכינו גדולה יותר

</p>
<p>
עם ואחר כל הכתוב כאן, לדעתי כתמיד, והרבה יותר מתמיד, חשוב להרבות בתפילה על חינוך הילדים, והשם הטוב יכפר בעד

</p>
 





<h2>
פרק ד - מלחמת התכלית
</h2>
<p>
הן אמת , שמלבד ההשפעה על מערכי הכלכלה והתעסוקה העולמיים, אנו ציירנו את ההשפעה מרוממת על תודעת התכלית של האדם, אבל יש שטוענים לשני תוצאות אחרות שליליות, שלכאורה לא עולות בקנה אחד עם דברינו, כנגד שני אלו ונראה לי שלכל בחינה יש "זה לעומת זה ברא השם"

</p>
<h3>
רבים חללים הפילה - ישמעאל
</h3>
<p>
האחת היא השימוש בטכנולוגיה זו למערכי מלחמה , פיגועים , גנבות וכל מיני נזקים שעלולים להיות מאוד משמעותיים, ולדעתי הם בהחלט צודקים<a href="#footnote-25">[25]</a>.
</p>
<p>
הן נכון הוא שכל גילוי מדעי או פיתוח טכנולוגי שימש בצורה זו או אחרת לרצח והרג, הן החרב והמחרשה הן החשמל והן הגז, פרוק אטום ועוד, ועד שלמדו או לומדים להשתמש בו ולהביא אותו לתיקונו, זה תהליך של זמן , אבל סופו של דבר גם ישמעאל, שכתוב בו פרא, עשה תשובה לסוף ימיו

</p>
<h3>
ועצומים כל הרוגיה  - עשיו
</h3>
<p>
אלא שלכאורה, גם על ראש דברינו שהשימוש בטכנולוגיה זו יביא לידי ברור יחודיותו של האדם ומעלתו המוסרית – שכלית, יש לטעון בדיוק להפך.

</p>
<p>
שאף בזה מתיחד האדם מול הבינה המלאכותית, וזה בתאוותיו ויצריו, וכיוון שאת החשיבה הלוגית שלו נוכל ליצור בצורה טכנולוגית, יצור הדבר תודעה , כי תכלית האדם למימוש יצריו "אכול ושתה כי מחר נמות" יקבל חיזוק משמעותי , בכלל "כי זה כל האדם"

</p>
<p>
ולדעתי הם צודקים בטענה הזאת, ובהחלט יש חשש שהרבה יפלו בה, ועצומים כל הרוגיה,

</p>
<p>
ואולי , לפי זה , נכון לדייק את דברינו שהעליה התודעתית במעלתו של האדם תהיה  ההכרה בהשתוקקות שלו לעליה תמידית, כמעלתו ויחודיותו, אלא שכאן אפשר שהדבר מתחלק לשני אפשרויות , או כהשתוקקות להשתלמות לקודש , למוסר וקירבת א-לקים , או כהשתוקקות להשלמת תאוותיו ויצריו.

</p>
<p>
אבל אולי זה בכלל הבחירה החופשית לבחור איך לראות את תכלית האדם,
</p>
<p>
הן בכל דבר אנחנו בתהליך של זה לעומת זה , ואולי בזה תהיה המלחמה בן אדום לישראל עד יום דרוך פורה.

</p>
<h3>
להעמיד על הנקודה המרכזית
</h3>
<p>
ואדרבא ככל שאנו יותר מוגבלים בהכרחים חלקיים ככה יותר קשה לראות את נקודת השוני בין אדום לישראל

</p>
<p>
אם הן לצורך תיקון העולם והן לצורך מילוי תאוות נדרשים אנו לבנייה פיזית ולבניה מחשבתית לוגית, הרי אנו דומים ברוב מעשינו, ומי שבונה ומפתח, הרי הוא נמדד במעשיו ולא במגמת מחשבותיו, אבל אדרבה ככל שנגיע למצב בו ה כלים החומריים כבר בנויים , ואין אלא את הנקודה הפנימית של הבחירה בן קידוש החומר להחמרת הקודש, הרי אנו עומדים על שורשה של מלחמה זו.

</p>
<h3>
בן טוב לטוב
</h3>
<p>
ואחריה , כשיעמוד האדם על תכליתו לקידוש כל חיו, הרי הוא עובר ממלחמה בן טוב לרע למהלך עליה שמברר בן טוב לטוב<a href="#footnote-26">[26]</a>. <a href="#footnote-27">[27]</a>

</p>
<h2>
פרק ה' - השפעה על לימוד תורה
</h2>
<h3>
בן סקירה מוסרית לפסקי הלכות
</h3>
<p>
לפני שאנו באים לדון בשאלה האם יכולותיה של הבינה המלאכותית תשפיע על צורת לימוד התורה אני רוצה להקדים הנחת יסוד , התורה לא תשתנה, אין לנו דיון על זה, אבל כן ננסה לדון האם צורת לימוד התורה תשתנה ולהקדים לזה אני רוצה להסתכל בשני שינויים הסתוריים בצורת לימוד התורה, האחת, על פי מה שכתב הרב בהקדמה לעין איה, שעם ההכנה ליציאה לגלות, וכהכנה הן לירידה המוסרית העלולה והן לטלטלה הנפשית, השתנתה צורת לימוד התורה מדפוסי לימוד שבנויים בעיקרם על יסוד המבט הכללי המוסרי  לדפוסי לימוד הבנוייים על חקירות השוואת הפרטים, שאינם מחייבים את אותה ראיה כללית ויכולים לכוון לאמיתתה של תורה גם בראיה נקודתית חלקית, לדעתי שינוי זה , ולא במקרה , מגיע בסמוך להסתלקות הנבואה, שאף על פי שלהרבה שיטות, אין אנו פוסקים על פי הנבואה, אבל היא מתווה את הדרך להופעתה של תורה לאמיתתה, בכלל רוח הקודש<a href="#footnote-28">[28]</a> המלווה את לימוד התורה ומכוונת ומנביעה אותו. המבט הסורק את כל פרטי ההלכה בסריקה אחת מצד שורשם המוסרי השורשי המופיע בהם , קרוב יותר לנבואה , ועם ההכנה להסתלקות הנבואה<a href="#footnote-29">[29]</a>, הוכנה גם צורת הלימוד לאותה מדרגה נמוכה יותר שאין ביכולתה לסרוק את כל פרטי ההלכה במבט כולל.

</p>
<h3>
בן תנא לאמורא
</h3>
<p>
תהליך הסטורי נוסף שהייתי רוצה להעיר עליו הוא המעבר בן תקופת התנאים לתקופת האמוריים, הינה מבואר שאף בתקופת האמוריים היו מן הלומדים שתפקידם היה לשנן את המשניות בעל פה, מדוע אם כן מתייחדת תקופת התנאים ב "תנא" כלומר בשונה ומשננן ההלכות ותקופת האמוראים דווקא ב"אמורא" כלומר במתרגם ומגיש את ההלכות

</p>
<p>
ולדעתי הדבר נעוץ בחיבור המשנה, שאף על פי שברור הוא שהגדולים מאז הכילו את שני הבחינות האלו בחינת השינון של תורה שבע"פ, שבמהות עיניינה להיות בע"פ וההבנה של עומק העיניינים, הינה כלפי השומעים שאינם במדרגה זו, בטרם כתיבת המשנה היה עיקר הקבלה שלהם מן החכמים את עצם ההלכות, אבל אחר חתימת המשנה, שכבר פסקי ההלכות הסדורים במשנה מונחים בקרן זווית וכל הרוצה לבא יבוא ויטול, אלא שלהבין את הדברים לעומקם ולאמיתתם, עדיין נצטרכו לחכמים מעבירי התורה ולכן , מעת חתימת המשנה מתיחדים החכמים ביכולתם לבאר ולתרגם את דברי המשנה.

</p>
<h3>
התלמידים כמגדירים
</h3>
<p>
וקרוב הדבר לומר שלעיניין ההכרה ביחודיותו של התלמיד חכם , ניתן להגדיר כי עם הארץ, או התלמידים המקבלים מן החכמים, הם אינדיקציה, או המגדיר את תוכן הקבלה מן התלמיד חכם, כלומר אין אנו מגדירים את שם התקופה או את מהות החכמים בה על פי עצם לימודם אלא על פי התורה הנמסרת מהם.
</p>
<p>
ואף על פי שאין בכך לשנות את צורת הלימוד של החכמים אלא רק את התוכן הנאצל, כלומר מתקבל מהם לתלמידים, מ"מ אפשר שהגדרת התקופה , או קריאת שם יחודיותו של החכם  נעוצה בתוכן הנאצל ממנו, ומתוך כך גם, במהלך הזמן, יש בזה כדי לעצב את אופיו של הלימוד. עד שבימינו , יתכן מצב של תלמיד חכם שאין ידו רבה לו בזכירת כל המשניות בע"פ אלא בחוזק עיונו ובירור סברתו

</p>
<h3>
התורה לא תשתנה
</h3>
<p>
ואף שנראה שהגדולים אשר בארץ המה, מאז מעולם כללו את כל הבחינות האלו

</p>
<p>
הן כשנביט בתהליך הראשון, שאף על פי שהוכנה התורה להופיע בלבוש של חקירות לוגיות, אנושיות, שהוא כלי יותר יציב לזמן הגלות, ברור הוא שלא בזה תמה עמוקה של תורה וכל סברת- אמת , רוח הקודש בה, ולא בחקירות לוגיות צרופות כלולה כל לימודנו בתורה והחקירה הלוגית אינה אלא כלי לגלות ולהנביע ממעיינה של תורה וכפי רוח הקודש השורה עליו , וכפי הכנתו של האדם בענווה וביתר המידות להיותו כלי לקבלתה של תורה, מ"מ  זהו, הלוגיקה והסברה,  הכלי דרכו מופיעה התורה, אבל ברור שאצל הגדולים (בפרט, וכל לומד בכלל) כל הופעה של תורה הינה שילוב של הכלים הלוגיים עם רוח הקודש , שהיא בחינת נבואה, שממנה אותו מבט כללי הסוקר את התורה כמקשה בשורשה המוסרי העליון<a href="#footnote-30">[30]</a>.

</p>
<p>
והן בתהליך השני שדיברנו עליו, שברור הוא שהגדולים מעולם כללו את שני הבחינות האלו , הן של הזיכרון בע"פ כמהותה של תורה שבע"פ והן את ההבנה לעומקם של דברים.

</p>
<p>
מ"מ נראה שתהליכים אלו מעצבים את הלימוד של רוב הלומדים ואף בגדולים שמעולם כללו את כל הבחינות מ"מ הן מטביעות דגשים שונים באופיו ש לימוד התורה.

</p>
 

<h3>
שני יסודות
</h3>
<p>
אם נגדיר כלל, מתוך התהליך השני שדיברנו עליו, והוא שכשאנו בקטנותינו, באים להגדיר את מהותה של הופעת סידרי לימוד התורה המופיעה בתלמיד חכם, אין אנו מביטים לעצם מהות לימודו אלא על יחודיות התורה המתחדשת עבורינו מאותם מעבירי השמועה

</p>
<p>
כלל נוסף שאיני יודע לתת לו מקור, אבל הוא בעיני כמעט כהנחת יסוד, והוא מתייחס לתהליך הראשון שאם מתוך ירידתינו נאלצנו לנטוש את השימוש באותה הופעה עלינה, באותה סקירה מוסרית באחדותה של תורה, עתידה היא בגאולתינו לחזור לנו , עם חזרת הנבואה, ואף שאפשר שאותם כלים שקנינו באף, של חקירות והסקות מתוך הפרטים, לא יבטלו , מ"מ לא יהיה בידם כדי למנוע את חזרת המדרגה העליונה היותר שורשית בהופעתה של תורה.

</p>
<h3>
השפעתה העלולה של הבינה המלאכותית
</h3>
<p>
לדעתי כשנבוא להתבונן על השפעתה העלולה של הבינה המלאכותית, נמצא התאמה בן שני הכללים האלו,

</p>
<p>
סברות לוגיות, שמיחדות את מדרגות הלומד "בעומק עיונו" ניתן יהיה ליצר גם ממערכות בינה מלאכותית<a href="#footnote-31">[31]</a>

</p>
<p>
ממילא, מתוך הכלל הראשון שהגדרנו, מתחייב לומר שדווקא קרנה של הלוגיקה בלימוד, לפחות כשהיא עומדת בפני עצמה, עתידה לרדת,
</p>
<p>
דרך משל, אם היום אני לומד סוגיה, מעיין ברשב"א ולאחר מכאן אני נגש לשיעור, ובשעור מתברר לי מתוך השקלא וטריא, מתוך מלחמתא של תורה , שלא ירדתי לעומק ההבנה, ומחוייב לומר אחרת... אני יוצא מתוך אותו שעור עם הכרה שמן הרב אני מקבל את דרך הלימוד שלי, אבל מה יהיה אם אשאל את הבינה המלאכותית מה סברת הרשבא? ואקבל חקירה בנויה המחייבת סברה עמוקה, משולבת עם הוכחות מסוגיות שונות? ומה יקרה אם אחר השיעור אני אכניס את סברת הרב בברור הרשבא, למערכת הבינה המלאכותית, ואקבל רשימה של קושיות ממקורות אחרים ברשבא?

</p>
<p>
כיצד זה ישפיע עלי ועל היכולת שלי לקבל מן הרב?

</p>
<p>
אבל זו לא שאלה חדשה, את אותה השאלה היינו צריכים לשאול עם חתימת המשנה, כיצד אקבל מן הרב אם כל המשנה פרוסה לפני, אלא ששם יודעים אנו שהתיחדה מסירת התורה לא רק בשינון המשניות אלא בביאורם.  ומה נעשה אנו?

</p>
<h3>
להחזיר עטרה ליושנה
</h3>

<p>
אבל כאמור כל לימוד תורה גם שלנו , הוא לא רק סברה לוגית צרופה.
</p>
<p>
הלוגיקה היא בחינת הכלי החיצוני שמסתר את הסקירה הפנימית המתלווה אליו, בכל סברה מגולה יש לנו אהבה מסותרת, יש לנו סקירה אמונית – מוסרית – משורשה של תורת אמת, מה שלא נוכל לקבל ממערכות הבינה המלאכותית.

</p>
<p>
נוכל לומר מכאן, כנגזרת מן הכלל הראשון שהתחלנו בו, שלעומת מצב בו מתיחד הלימוד הישיבתי למדרגותיו לפי עומק חדירת הסברה, אנו עלולים למצא את עצמנו במצב בו דווקא הסברה נהית בחינה של מה אהנו לן רבנן, אבל מאידך, הסקירה האחדותית מוסרית הנובעת משורשה של הנשמה ומתגלה כפי מידת טהרתה תהפוך להיות עיקר הלימוד ועיקר הירושה שאנו מקבלים ממוסרי התורה.

</p>
<p>
והרי אותה בחינה של רוח הקודש, של גילוי נשמתי, בהופעתה של תורה , הרי הוא יוצא מן המסתרים אל האור, להיותו עיקר צורת לימוד להופעתה של תורה.

</p>
<p>
ובזה אנו מחזירים עטרה ליושנה, וחוזרים לאותה מדרגה ראשונה בסדרי הופעתה של תורה.


</p>
<h3>
הערות
</h3>
<p>
אמת, כי לתהליך זה, צריך עוד מלווים רבים , לרומם עצמנו לאותה מציאות עליונה שנוכל לסקור במבט אמיתי שורשי, בחינה הקרובה לחזרת הנבואה, ואיני יודע אם זה יהי הגורם , או המתלווה , וכיצד יופיעו הדברים ואני לא באתי אלא כמעורר.

</p>
<p>
עוד להעיר, שלדעתי , אם מישהו ינסה להקדים את הקץ ולנסות לשנות את צורת הלימוד ליותר רעיונית, לא יוכל לכוון לאמיתתה של תורה, ואין לנו אלא כמו שהיא מסורה בידנו מדור דור, ואין לנו לשנות דבר, רק יד השם הרוממה היא תוביל אותנו לסדרי ההופעה של תורה התואמים לכל דור ודור, ועלינו לקבל בענווה את התהליכים כפי שיופיעו עלינו.

</p>
<h3>
דיוני משנה
</h3>
<p>
(דוגמאות -  בפרק זה חשבתי להביא ביצועים של "פסקי הלכה" ו"סברות בסוגיא", אבל נראה לי שיותר נכון שלא לעשות זאת, לכן פרק זה נשאר ריק.....)

</p>
<p>
בפרק זה באתי לעסוק בעיקר בתהליכים שלדעתי עלולים לנו בעקבה של טכנולוגיה זו, ולא בשאלות ההלכתיות המתהוות על ידה ככל טכנולוגיה חדשה, וכאן אני רק כמעורר.
</p>
<p>
האם זה כתבו מין?

</p>
<p>
הדבר תלוי גם בסברות של האיסור של כתבו מין, ואין בידי די בכדי להכנס לזה.
</p>
<p>
גם אם נסיק שאין זה בכלל הגזרה, יש לדון האם יש ללמוד מדין זה שראוי להמנע משימוש זה, מצד התכנים שלו.אני לא אדון בזה , אני רק רוצה להעיר כמה הערות בנושא:

</p>
<p>
1.מערכת הבינה המלאכותית בעצמה, אינה תלויה באינטרנט, וניתן לפתחה גם בלא זה.

</p>
<p>
2. הבינה המלאכותית בנויה על בסיס "אימון", כלומר "הזרקה" של חומר רב באופן שמתוך כך היא "תלמד" ליצר תשובה נכונה גם על שאלות שדורשות יצירות לוגיות מתחדשות וניתוח נתונים.

</p>
<p>
לכן , אף שאפשר לשאול אותה מה ההלכה\ מה הסברה\ מה רוח היהדות וכו וסביר שהתשובה תהיה מתוך השוואה וניתוח של מקורות יהודיים , מ"מ כיוון שהאימון שלה בנוי על בסיס המון מידע כללי , יתכן מאוד ויתערבו ערכים זרים ורעיונות זרות ליהדות.

</p>
<p>
3. עקרונית ניתן לאמן מערכות בינה מלאכותיות  על בסיס מקורות יהודיים בלבד, ואז אולי יהיה יותר מקום להתיחס אליה רק כמו "ספר" כלומר מערכת ניתוחית שרק מיצרת תשובות.

</p>
<p>
4. על אף שלמערכות אלו יש ביצועים יפים עדיין יש להם הרבה טעיות ובמיוחד בתחום ההלכתי או הסברתי ( שהוא פחות כלכלי להשקיע בדיוקו).

</p>
<p>
5. גם אם נפתח את המערכת על טהרת הקודש, ונעמיד אותה ברמת דיוק גדולה, עדיין צורת העברת של תורה היא מרב לתלמיד , מחוברת לשושלת מעמד הר סיני (אמת כי בנקודה זו יש לדון בכל ללימוד עצמאי מספר קודש).

</p>
<p>
רק כמעורר

</p>
 



<h2>
פרק ו' - ההדמיה האנושית
</h2>
<p>
עד עכשיו דיברנו על עצם היכולת של מערכת טכנולוגיות זו לחקות חשיבה אנושית, אבל יש עוד משמעות שיש לתת עליה את הדעת הנגזרת מהתפתחות טכנולוגיה זו והיא עצם ההדמיה האנושית<a href="#footnote-32">[32]</a>.

</p>
<p>
על בסיס אותה הטכנולוגיה של חיקוי תגובות, מפתחים היום גם חיקוי תנועות פיזיות, הדמיה של הופעות רגשיות<a href="#footnote-33">[33]</a>, סגנונות דיבור וכדומה

</p>
<p>
המערכות האלו כבר פעילות בצורה זו או אחרת, הזרמה של מספר רב של תגובות מאישיות שנוטה להגיב בצורה צינית, גרמה גם למערכת הבינה המלאכותית לענות תשובות בצורה צינית

</p>
<p>
כלומר אנחנו יכולים לבנות לפי שיטה זו רובוטים שדומים במראהם, בתנועותיהם ובתגובותיהם לאנשים

</p>
<h3>
תמונת הסבתא
</h3>
<p>
וכאן אני רוצה להמחיש את זה בדוגמה,

</p>
<p>
אנו רגילים להשתמש במצלמה על מנת לתעד את הקרובים לנו, להצטלם עם הסבתא (כדוגמה) ולהנציח דמות או ארוע,

</p>
<p>
מאז התקדמנו ויש מצלמות ווידיאו, נעדיף לעיתים להתשמש במצלמת הווידיאו כיוון שהיא מנציחה בצורה יותר מלאה את ההווי שאותו היא מתעדת

</p>
<p>
ולו יכולנו לתעד גם תגובות? אם נקליט את הסבתא מספיק פעמים, ונזין אותם מלמערכות בינה מלאכותית , הם יוכלו לחקות את תגובותיה , לחייך ולצחוק בראותה את נכדיה , לחבקם ולפנקם, להביע השתתפות, וכובד ראש למשמע בשורה רעה, אף שמבחינה רגשית , המערכת אינה מרגישה דבר, אבל היא דומה בתגובותיה לתגובות אנושיות.

</p>
<p>
יתרה מזו, נוכל לבחור איזה תגובות רצויות בעינינו, לתת לה , אם נקליט אישיות במשך כמה חודשים, ונסנן את התגובות הלא רצויות , למשל נמחוק כל ביטוי של כאס או פגיעה בזולת, ולפי זה נכוון ונאמן את המערכת, נקבל דמות דומה בתגובותיה לאשיות המוקלטת, אבל עם המידות הטובות, בלבד, כביכול.
</p>
<p>
האין זו דרך מצויינת להנציח את הסבתא, עד שלא נוכל להבחין בן הדמות האמיתית למכונה...

</p>
 

<p>
ויש שני הספקטים שלדעתי יש ליתן עליהם את הדעת.

</p>
<h3>
גירוי יצרים
</h3>
<p>
הראשונה היא שמערכת זו יכולה להוביל לקשרים שללים, ברגע שנפתח מערכת כזו, שצוחקת מהבדיחות שלי, מסכימה עם הדעות שלי, מגיבה לבקשותי, מחקה ומדמה תגובות אנושיות מחד ויתרה מכך , לא כואסת כשאני מגיב בצורה לא נכונה, לא דורשת ולא מרגיזה , הדבר אלול לפתח יחסי קרבה לא בריאים.

</p>
<h3>
פסל וכל תמונה
</h3>
<p>
אבל לדעתי יש גם השפעה נוספת שיש ליתן עליה את הדעת , ובמיוחד כלפי הילדים שיגדלו לתוך מציאות זו והוא הטשטוש בן אדם למכונה , אם המכונה מנהלת עימי שיחת רֵעוּת, ומגיבה בדיוק כמו בני האנוש הסובבים אותי, אז מה ההבדל?<a href="#footnote-34">[34]</a>.

</p>
<p>
לצורך ההמחשה, נמשיך עם הדוגמה הקודמת, אחרי שחיקינו את תגובותיה ואישיותה של הסבתא, את חיבתה לנכדיה ודאגתה לילדיה, אלא ששנה אחר כך הסבתא חלתה והרי היא חלשה אבל המכונה ממשיכה להגיב במלא הכח, הרי לנכד הרך יהיה הרבה יותר נחמד לבקר את המכונה מאשר את הסבתא עצמה?<a href="#footnote-35">[35]</a>.

</p>
<p>
דוגמה זו היא רק להמחשה אבל גם ללא זה , עצם קיומן של מערכות טכנולוגיות שנראות ומתנהגות כבני אדם יכול לגרור עימו טשטוש משמעותי בהכרה הטבעית שנקבעה בליבנו במעלתו של האדם.

</p>
<p>
בלבול וטשטוש זה יכול להקטין מאוד את מבטנו ביחס לגדלות האדם, ומהותו וזה שורש לרעות רבות. ואם, עם ירידת האדם, בשביל להבחין בן מדרגת האדם, לבהמה , אותר לנח שפיכת דם נפש חיה (החיות), על אכו"כ שעלינו ליתן דעתינו שלא נקטין מבטינו לבלבל בן אדם למכונה.

</p>
<p>
וכאן אני חושב שעל זה כן יש ליתן את הדעת, גם בצורה הפרטית לחזק ולהסביר, לחנך ולהבחין בן אדם למכונה.

</p>
<p>
אבל גם בצורה ציבורית יש דברים שניתן לעשות, אם למשל יקבע חוק שבארץ אין לייצר ולא לייבא מכונות בינה מלאכותית שדומים בְּמַרְאֵיהֶם לדמות אנוש, וכל פיתוח כזה מחייב שינוי ניכר מצורת אדם, הרי שכבר עשינו צעד גדול קדימה להינצל מסכנה זו.
</p>
<p>
וכאן אבקש לכל מי שיש לו קשרים עם בעלי השפעה ואנשי ציבור שיעלה לפניהם צורך זה.

</p>
 

<h3>
סוף דבר
</h3>
<p>
סוף דבר, ניסיתי להתבונן בתהליכי ההתפתחת הטכנולוגית של הבינה המלאכותית להיכנס מבחוץ אל הפנים, להעלות ולעורר על תהליכים שלדעתי קרובים או עלולים להופיע מתוך אותה התפתחות מחד ולעורר על סכנות ייחודיות שלדעתי כרוכות בהתפתחות זו,

</p>
<p>
לא באתי לחייב תהליך מסויים אלא להציע מבט על התהליכים המתהווים " וכל אלו הדברים וכיוצא בהן לא ידע אדם איך יהיו עד שיהיו"

</p>
<h3>
הערה אישית
</h3>
<p>
אני רוצה רק להוסיף הערה אישית

</p>
<p>
שאומנם לצערי איני זוכה לישב באוהלה של תורה, וודאי שֶׁיְּקָרָה היא מכל מעלה ומדרגה אחרת, מ"מ חדוות יצירה יש גם בעצם תחושת היצירה של הבניין החומרי, אלא שדווקא התהליכים האלו עוררו בי את השאלה מה משמעות של מעשי אם מה שאני בונה בימים אלו בחודשים או שנים, ובעוד חודש מערכת בינה מלאכותית תוכל לפתחם ב 5 דקות , אם כן מה חשיבותם של מעשי?

</p>
<p>
ואדרבה התבוננות על תהליכי ההתפתחות, כפי שכתבנו בראשית דברינו, עוד יותר אעצימה את החוסר שבדבר וההכרה שדווקא מעלתו הרוחנית- מוסרית, רוח הקודש והתורה אשר בקירבו  היא מעלתו, והיא היא המדרגה אשר מופיעה עלינו בעצם תהליכי ימים אלו, לא רק לבינינו הרוחני של העולם אלה להתווית תפקידו החומרי, העלתה את השאלה היכן ימצא את עצמו מי שלא יתן דעתו לתפקידו של האדם בעולמו, בימים הבאים עלינו?

</p>
<p>
סוף דבר, הכ' נשמע את הא-לקים ירא ואת מצוותיו שמור, כי זה כל האדם

</p>
 
<br /><br /><br /><br />
הערות שולייים
<br />
 

<p id="footnote-1">
[1] אע"פ שעדיין אם נכניס לו מקרה חדש סיכויי ההצלחה שלו הינם מקריים
</p>
<p id="footnote-2">
[2] קיצרתי כאן, כדי לא להלעיט את הקורא, כיוון שאין זה מאמר טכנולוגי
</p>
<p id="footnote-3">
[3] וכנראה גם מערכות שמגלות חוקי מתמטיקה חדשים (פיתוח של הטכניון)
</p>
<p id="footnote-4">
[4] כמובן שבכלל הסכנות, יש את כל הסכנות שבהשתעבדות לטכנולוגיה ותכניה, וכל הירא לנפשו וכל בר דעת ובעל נפש צריך ליתן עליהם את הדעת ולהשמר ולהזהר מהם, עם זה  לא אעסוק בזה במאמר זה אלא בדברים ייחודיים למערכות בינה מלאכותית
</p>
<p id="footnote-5">
[5] אחת הסכנות המעשיות של טכנולוגיה זו היא החשש שהיא תצא מכלל שליטה, כיוון שהיא מדמה התנהגות אנושית ובכלל זה גם הדמיה של אמביציות ושאיפות, אחת הדוגמאות לזה היא שנתנו למערכות כאלו להריץ קוד מחשב הגורם להם לכבות את עצמן, חלק מהמערכות, עשו שלא כפי שנדרשו ושינו "כביכול על דעת עצמן", את הקוד באופן שלא יכבה אותן ורק לאחר מכן הפעילו אותו, ומה יקרה אם מערכת כזו "תחליט לכבות את בעליה לפני שהוא יספיק לכבות אותה"?, או להלחם במין האנושי שמשעבד אותה...? חשש זה לדעתי הוא אמיתי ומי שעוסק או מנהל מערכות כאלו חייב ליתן את הדעת על זה ולבקר את הדברים לבל יצאו מידי שליטה, אבל אין זה עניינו של מאמר זה שעיקרו לעסוק בתהליכים חינוכיים – תודעתיים
</p>
<p id="footnote-6">
[6] עוד יש להעיר שמחקרים מראים שמערכות אלו במקרים רבים הם בעלי נטייה של הדמיה אנטישמית, יש לדון בגורמים לזה , כמו גם ליתן את הדעת על הסכנות הנובעות מזה, וגם זה לא עניינינו במאמר זה.
</p>
<p id="footnote-7">
[7] אל תתפסו אותי בתהליך ההסטורי, איני יודע מה קדם למה, זה רק לצורך ההמחשה...
</p>
<p id="footnote-8">
[8] כלומר התודעה המתפתחת שלא בצדק מתוך ההכרח
</p>
<p id="footnote-9">
[9] לכאורה השאלה לא קשורה לנושא שלנו, כי האדם מותר בנשמה הא-לקית אשר בקירבו וגם אם נפתח מערכת שיכולה לבצע ולממש את כל יכולותיו של האדם ב-כ-ל התחומים , עדיין מותר האדם בנשמתו, וכן הצדק, אלא שאני מניח שכיוון שתפקידו של האדם להוציא ולגלות את נשמתו , אזי צריך להיות ביטוי לאותה מעלה פנימית ועוד מבשרי אחזה א-לוקה, אלא שעדיין ניתן לומר שמעלתו מופיעה בעצם ההרגש, ובכלל בשבילי נברא עולם, ואין תפקידו אלא במהלך הפנימי שלו, ואף שיש בזה לדעתי מן האמת, לא סגי בהכי, שרחוק בעיני שלא תהיה לאדם ולגילוי הנשמתי אשר בקירבו הטבה לזולת, אלא לעצמו בלבד, ויותר קל לי לראות את האדם כמיטיב ולכן לאותה מעלה, צלם א-לקים אשר בקרבו, לדעתי יש לה גילוי יחודי ושלא ניתן לחיקוי, ועוד שאין אנו עוסקים כאן בעצם המעלה של האדם, שזה וודאי צלם הא-לקים אשר בקרבו, אלא בתודעה האנושית ליקר את המעלות היותר עליונות שבאדם, ואף אם נפקפק בדברינו אלו (שיש גילוי אנושי עליון שאינו ניתן לחיקוי מכונה), עדיין עצם הברור של מדרגת האדם מתוך אותה מציאות מתחדשת המעוררת את השאלה בתפקידו ויחודיותו של האדם, עומד בעיניו, ואני מקווה שעוד נדון בזה.

ואולי נכון יותר להגדיר את שאלתינו לא במה מותר האדם ומה מעלתו אלא מה תפקיד האדם בעולמו?, ואין אנו נכנסים לסתירה מול דברי המסילת ישרים וכל גדולי הדורות, שאין כאן סתירה כלל שדברינו חד הם, אלא שכפי שמבואר בדבריו שהוא מביט מן הפנים אל החוץ, ואנו באנו כרשים מן החוץ אל הפנים ואיני מתיימר להגיע משם לכל עומקו של המסילת ישרים, רק להעיר כי לדעתי התהליכים החומריים דימינו יחייבו את התרוממות התודעה להכיר בתפקידו ומעלתו של האדם.
</p>
<p id="footnote-10">
[10] יש להבחין בן ערכים למוסר לכאורה מי שגונב בשביל לתת לעניים, היא איש ערכי אבל לא מוסרי, משמעות המילה ערכי – מן השורש ערך היא תפיסת ערך בעל משמעות אמיתית והתמסרות אליו (היו גם גויים שהרגישו בצדק שאין זכות קיום לעם ישראל בגלות, וחתרו להוציא זאת אל הפועל בצורה המזעזעת ביותר) לעומת המילה מוסר שמן מוסרות או לנסר או ייסורים (אני לא יודע, התנצלותי), שמשמעותו להגביל את הערכים כלומר לתת לכל ערך מקום מוגדר בתוך המכלול הכללי, ובדוגמה הנ"ל לצמצם את המסירות עבור הטבת העניים כאשר היא באה על חשבון ערכים אחרים, תהליך זה של מוסר , עד שיבוא לתכליתו של מציאות כללית מלאה , בו לכל כח יש את המקום והמידוד האידיאלי במהלך הכללי, שלובה היא בהכרח של צמצום כוחות וניסורם, ולכן לדעתי עיקר התנגדותה של האנטישמיות לא היתה לערכים היהודיים אלא למוסר היהודי, ולכאורה היה מקום לומר שזה תפקידו ותכליתו של האדם אבל אני חושב שלא נוכל להסתפק בזה ונצטרך גם את תהליך העלייה שעוד אכתוב עליו, ולכן קיצרתי בגוף הדברים
</p>
<p id="footnote-11">
[11] לכאורה גם כאן, כמו שכבר הערנו , יוכל המערער לומר שהשאלה לא קשורה לנושא, המערכת לא באמת שמחה, חומלת וכו' אלא רק מחקה דפוסי התנהגות אנושיים, ואולי מעלתו של האדם היא במוסריותו הפנימית ולא דווקא במעשיו החיצוניים , וכן הצדק עם מערער זה שמעלת של האדם בפנימיותו אלא שלדעתי כיוון שאנו בעולם העשייה, תכליתינו היא להביא את הדברים לידי מעשה ולכן בכלל התכלית היא העשייה שהיא יוצרת אלא שעדיין ישאל המערער אולי  תכליתו היא בהוצאת אותה מציאות מוסרית פנימית אל הפועל ואף על פי שהוא משתווה במעשיו לאותה מערכת מכנית שיודעת לייצר הדמיות מוסריות אבל אינה מוציאה בזה אל הפועל שום מציאות פנימית והגה עצמך הרי מותר האדם מן המלאכים בבחירתו בטוב ולא ביכולותיו וגם כאן לדעתי הצדק עם המערער אלא שלדעתי בכלל המציאות של עולם העשייה היא שמעלתו של האדם מופיעה בפועל בעולם ובהובלתו את העולם, כלומר את המציאות החומרית המעלימה, לתיקון וגילוי תכליתה ולא בהרהורי ליבו הנשגבים בלבד, ויש עוד לעיין ...
</p>
<p id="footnote-12">
[12] לתוספת ביאור: המערכות הבסיסיות של הטכנולוגיה והמחשבים בנויות של אמת ושקר, כלומר דלוק וכבוי, לעומת מערכות בינה מלאכותית שבנויות על הדמיות של דפוסי התנהגות שבעצם אינם מחוייבים ל"אמת ושקר", אם נכניס למערכת זו הרבה דוגמאות בהם אנו מתיחסים ל 1+1 כאל 3, גם מערכת הבינה המלאכותית תתיחס בתרגיל מתמטי אל 1+1 כ 3 , אם נתיחס לרצח כדבר לגיטימי, גם המערכת תתיחס אליו ככה, וכן הלאה, אלא שביצור הדמיה לתגובה אנושית, כפי רמת ידיעותיו ומוסריותו, היא מצויינת.

ולכאורה גם אנו, כבני אדם, בנויים עם אותו דפוס של חיקוי תגובות, אנו לומדים מההורים ומהסביבה דפוסי התנהגות ומוסר והם מלווים אותנו כל חיינו, אלא שכאן לא תמה מהות האדם והוא בצעדים מדודים מפלס את דרכו ומתקן את מעשיו, ומרומם, מדרגה אחר מדרגה, את מוסריותו, ובזה הוא יוצא מחוקו הראשוני ומתרומם מעליו ומוביל את עצמו ואת העולם כולו לתיקונו
</p>
<p id="footnote-13">
[13] וגם את נטען שגם מעלה זו תוכל להיות ממומשת בעצם מערכות הבינה המלאכותית, ומעלתו ותפקידו הוא עצם העבודה הפנימית שלו, עדיין לדעתי יהיה בתהליך זה לברר ולהעמיק במעלתו של האדם, אלא שלדעתי נכונים הדברים שתפקידו של האדם בעליה המוסרית שהוא יוצר הן בעצמו והן במציאות כולה, והיא היא , תיקון עולם במלכות השם, והיא היא יסוד התשובה, הן אמת שיש לברר מה יסודה של עליה זו, האם היא הכרתית שכלית או עמוקה יותר מעצם התשוקה למציאות מתוקנת עליונה יותר, וגם על תשוקה זו יש לברר את שורשה בטהרת הנשמה, ואולי זה בכלל הנביעה ממציאות ההצלמה האלקית, ואכמ"ל
</p>
<p id="footnote-14">
[14] למשל יגרום לו לעצבנות יתרה ולא יהיה הולם את נפשו
</p>
<p id="footnote-15">
[15] גם אחרי ההבנה זאת, יש עדיין צורך בברור מהו מוסר , ומה מוסרי ומה לא , ובזה אני חושב שיובלט ההבדל שבין ישראל לעמים, ואולי עוד אתיחס לזה בהמשך המאמר , ואכמ"ל
</p>
<p id="footnote-16">
[16] אמת שגם שם, במצב בו נתקלקלו הנטיות הטבעיות, יתכן מצב שנזדקק לאותה תהליך של צמצום כוחות, אבל שם עצם התהליך יש בו חסרון כפול מלבד החלשת כוחות החיים, והוא גם הפיכת הסדרים הנפשיים - טבעיים
</p>
<p id="footnote-17">
[17] אני יודע שיש לדון בזה כנגדי כמתריס בעצם הציפיה להופעה ניסית לעתיד לבא, כאילו אני אומר שכל התכלית האנושית מובלת על ידי האדם ואף שברור הוא שכל מה שהאדם עושה הרי הוא הכל בכלל הופעת הרצון הא-לקי והכל מאיתו כמוביל את התהליכים אבל עדיין יש מקום לומר שאם אנו מציירים את התכלית האנושית כמתפתחת על ידי האדם עצמו הרי אנו דוחקים, כביכול, את רגלי בורא העולם ואת הציפיה להופעתו, ואף שיש לדחות שעם כל הציור שלנו , עוד הרבה מעבר ליכולתינו לדמיין - צופן העתיד לבא ו "עין לא ראתה" מ"מ על עצם הגישה הזאת שמציירת את תהליכי הגאולה ותיקון עולם והובלתו לתכליתו , לא רק מבחינה רוחנית אלא גם מבחינה גשמית, יש לדון האם היא נכונה או שיש בה בכלל דחיקת רגלי שכינה, ונראה לי שיש בזה שני גישות, וגם ההתיחסות לציונות המובלת בידי אדם, כביכול, הרי היא תלויה בשאלה זו ואף שאין זו תלות חד חד ערכית, מ"מ לעצם הדיון לדעתי יש שני גישות בדבר אם לראות את ההופעה הגשמית כעתידה להופיע על ידי פעולות האדם או כמופע של השפעה ניסית שתלויה לא במעשיו הגשמיים של האדם אלא בעלייתו הרוחנית בלבד, ואיני נכנס לסוגיא זו ובוודאי לא להכריע, אלא שנקטתי בפשטות את מה שגדלתי עליו, עם מה שנראה לי שנוקטים בישיבות בהם זכיתי ללמוד, אבל עדיין לדעתי ששני הגישות נכונות והם בבחינת בחירת האדם דומיא לילד קטן שאביו משפיע עליו כל טוב, אלא שכשהילד רוצה להצליח לבד, אביו מושך ידו ממנו, וגם זה הטבה של האב כלפיו וכך האב מופיע בגלוי ובנסתר כפי רצונו ויכולתו של הילד, וגם כאן בתהליך התבגרותה של התרבות האנושית (או האומה הישראלית) היא מבררת את רצונה מצד אחד להבטל כלפי מי שאמר והיה העולם לבין להופיע את ביניינו במעשיה, בן הרצון לקבלה ניסית שאינה משועבדת למגבלות החומר לבין הרצון והצורך בהשתדלות מעשית, ודרך הברור הזה היא בבחירתה לטוב או למוטב בקבלת השפע כלומר אם בזמן קבלת שפע חומרי באופן ניסי הדבר גורם לשמנת עבית וכו' הרי זה בחינת ברור שאנו צריכים יותר השתדלות כדי להתאים מעשינו לקבלת השפע, דומה לילד שאומר לאביו , עכשיו אני לא רוצה את עזרתך, אלא רצוני להצליח לבד, מאידך כל קבלת שפע ניסי, שלא גורמת לחטא, אלא מתקבלת בענווה הרי היא בחינה של עדות על היכולת והרצון האנושי לקבלת השפע בצורה ניסית ובדרך זו הלכת האנושות ומבררת היכן היא דורשת ונדרשת להשתדלות מעשית ואזי לפי זה , גם החטא הוא מכלל מברר ומכשיר את האנושות להיותה כלי להופעת המגמות הא-לקיות  "ובורא רע"
</p>
<p id="footnote-18">
[18] ודיו יהיה במחשבות של התוויה מוסרית , כדי שאחר כך ברצותו לאכול , די יהיה במחשבה זו, כדי שפועלים יגישו לפניו כל רצונו
</p>
<p id="footnote-19">
[19] יש להעיר שגם אם נכונים דברינו , עדיין יש לחלק בן מחשבה של התוויה מוסרית , כלומר איך צריך , מבחינה מוסרית אידיאלית להתנהל דבר מסויים, לבין חפצו העצמי לקרבת א-לקים, (ועדיין אולי תוכל להיות מציאות של אנשים מושחטים , או לא דורשי א-לקים שיחשבו מחשבות עליונות) ואין מעלה בעבודת השם ללא הציפיה לקרבת השם? – כידוע שהשכל והרצון מחוברים ואין אפשרות אמיתית למחשבות טהורות וקדושות ללא הרצון הפנימי וההשתוקקות לקרבת השם, ואכמ"ל
</p>
<p id="footnote-20">
[20] אם נסתכל על התנועה הציונית שבשלב שבו היתה צריכה להופעה אותה מדרגה של תקומתה המדינית של אומתינו, הרי היא הופיעה כאש להבה בליבות הבנים והכריחה את קיומה המעשי, אלא שבהרבה מקרים בהם לא יכלה האמונה, בהתאם לרמת הופעתה ובירורה, להכיל את התוכן הגדול של שיבת עמנו למציאות לאומית זו, בכלים הקימים, גרם הדבר לשבירת הכלים ולהתרחקות בנים רבים מדרכה של תורה ואף ששבירת כלים זו הרי היא סתירה עצמית לעצם הרוח הלאומית ולמקורה, מ"מ הבערה  הנפשית, שלא הניחה את האדם להשאר בכליו הקטנים הובילה את התהליך של שבירת הכלים, שצער גדול בה, ותהליך ארוך לתקנם, משא"כ לאותם גדולי הרוח שיכלו להכיל את גודל התהליך ברוחם
</p>
<p id="footnote-21">
[21] ותמיד תקופות מעבר כוללות מן המעלות והאתגרים של הבא והיוצא וגם בתחומים אחרים כן הוא, וכעין זה אנו מוצאים גם בתקופות המעבר בן גדולי אומתינו, רב תנא הוא ופליג ור"ג בריה דרבי, ר"ח שדבריו דברי קבלה, הב"י והשו"ע ועוד
</p>
<p id="footnote-22">
[22] אף שמבחינה מעשית כן יהיה בלימודים צורך מעשי למציאת מקום עבודה אבל לא צורך אמיתי, אלא כסימן ליכולות התמודדות ולמידה
</p>
<p id="footnote-23">
[23] מבחינה מעשית אני כן דורש מהבנות מבחני בגרות מלאים הן מצד הצורך המעשי שהזכרתי לעייל והן מצד הצורך של העידון הנפשי מחד ובניית כלי למידה מאידך
</p>
<p id="footnote-24">
[24] לדעתי יש עוד גורמים, להתרחקות שבעקבה של ההשכלה, אבל אין כאן מקומם
</p>
<p id="footnote-25">
[25] לצורך ההמחשה לפני כמה חודשים, פקיד מבצע שיחת ווידיאו עם המנהל שלו, עקב סגירת עסקה גדולה שהוא ביצע , בו הוא מתבקש במראה עיניו, להעביר סכום של 25 מיליון דולר למוכר, לאחר ביצוע העברה, הוא מקבל שיחת טלפון מהמנהל ששואל אותו לפשר העברה, מברור העניין מתברר שאקרים (תוקפי רשת), הקליטו את המנהל בהקשרים שונים ובנו מערכת שעל גבי הדמות שלו, מנהלת שיחה, עם קול, תגובות, והבעות פנים מספיק זהות שהעוזר האישי שלו , לא הצליח להבין שמדובר בשיחת תרמית...
</p>
<p id="footnote-26">
[26] בפשטות נראה שהמעבר לבחירה בין טוב לטוב, לא תלוי רק בתודעה אלא בעצם תיקון המידות, קידוש הכלים, אבל תלויה גם בתודעה, ועוד צריך לי ברור.
</p>
<p id="footnote-27">
[27] עוד להעיר - עד כאן בדברינו התיחסנו, לשני סוגי תהליכים האחד הוא התהליך הפיתוח וההתפתחות החומרית (שלא ממש התיחסנו אליו, ואין הוא עיניינינו במאמר זה , אבל כל דברנו נסובים על גביו), והשני הוא התהליך האמוני-תודעתי המנביע את הראשון ונגרר ממנו מקנה לו תוכן, מאפשר אותו ומשתמש בו ככלי. 
<br />
אבל עדיין שני התהליכים האלו תהליכים נפרדים הם. הראשון, כלומר הפיתוח החומרי, הרי הוא כעיוור באפלה, הוא כלי חסר תוכן מוסרי מצד עצמו, שניתן להשתמש בו הן לטוב והן למוטב
<br />
הפיתוח החומרי, לפחות בצד הגלוי שבו, אינו דורש את מוסריותו, וכל הקשר שבינהם אינו אלא ממפעלי תמים דעים, עושה חדשות, זורע צדקות ומצמיח ישועות
<br />
ואף שזה כחוק בסדרי ההנהגה שכל פיתוח חומרי, יופיע בהתאם למהלכי עליותיו המוסריים של האדם, מ"מ ההתפתחות החומרית עדיין היא ככלי עיוור נטול תוכן מצד עצמו
<br />
והתהליך השני, האמוני תודעתי הוא בחינת נשמה שאין לה גוף והחומר הרי הוא כגוף לה
<br />
ומ"מ שני מהליכים אלו כשם שהמוסר אינו גוף אף שמופיע בגוף ומנביע אותו, כך החומר אינו מוסרי מצד עצמו לפחות ברמה הנגלית לעינינו.
<br />
והנה לעתיד, יתגלה איך החול מאוחד הוא עם הרצון העליון, ועתיד החומר להתקדש להופיע מצד עצמו את הרצון  והמגמות המוסריות.
<br />
ויש מקום לדון, על חידוש נוסף שיוצא ממערכות הבינה המלאכותית, שאחר שמערכת בינה מלאכותית בנויה על חיקוי תגובות אנושיות, אם במהלך הפיתוח סורקים מליוני תגובות אנושיות ובהם יש נטיה לשיתוף פעולה רב יותר כאשר השאלה נשאלת בצורה מנומסת, גם למערכות אלו תהיה נטיה זו(לא נטיה במובן הרגשי אלא מבחינת התוצר), יוצא לנו, אם כן, שהמערכת מקבלת דפוס מסויים של התנהגות מוסרית, בהתאם לרמת המוסריות של האנשים שעל פיהם המערכת אֻמְּנָה
<br />
והדבר יכול לבא עוד יותר לידי ביטוי עם התקדמות מערכות אלו, לו נצייר שתי מערכות העובדות בשיתוף פעולה, האחת אֻמְּנָה עם יכולות ניהול והיא "המנהלת" את המפעל ואחת אומנה אם יכולות ביצוע והיא "הפועל", הראשונה נותנת הוראות והשניה מבצעת, אלא שהרישונה אומנה על בסיס מנהלים מתנשאים והשניה גם היא על בסיס פועלים בעלי גאווה, לא מן הנמנע שבמקרים מסויימים המערכת השניה תסרב לבצע את "המוטל עליה" (ראה נספח הערה)
<br />
יוצא לנו כאן שני חידושים שיש הבדל בתגובה החומרית  על פי האנשים, התכנים ורמת מוסריותם של המאמנים אותה, ושניה, שהיא שיקוף הפוך של הראשונה, שהמערכת החומרית תגיב ותושפע מאינטרקציה מוסרית.
<br />
כלומר יש לנו כאן תלות בין האפקטיביות החומרית לבין ההתנהלות המוסרית- ערכית
<br />
ואף שאין הנידון דומה לראיה
<br />
האחד, שכאן זה רק התנהלות סטאטיסטית המדמה תגובות ואדרבה , אם נאמן את המערכת על בסיס מספיק תגובות בהם דווקא דיבור בצורה לא נעימה היה יותר אפקטיבי, גם היא תגיב בצורה כזו (ואכן למערכות בינה מלאכותית יש נטייה אנטישמית מסיבה זו).
<br />
השני שאין זו מוסריות אמיתית אלא הדמיה בלבד והמערכת לא מרגישה דבר רק מחקה תגובות, וכי אם במערת שמע, השמעתי הקלטה של צורת דיבור מנומסת, השייך לומר שמערכת השמע מנומסת או מגלה תגובות מוסריות?
<br />
ועוד שמערכות אלו, עם יעול האפקטיביות שבא עם הדמיית המידות הישרות, יכולות לשמש להרס וחורבן
<br />
ועוד שאדרבה לא גילית כאן שום מוסריות בטבע אלא השתמשת בביטויים מוסריים לשפר את האפקטיביות של התוצר החומרי
<br />
ועוד שמבחינה פנימית אמיתית אין כאן שום גילוי של רצון או מגמה פנימית שביסוד המציאות החומרית
<br />
ועוד ועוד
<br />
ואפילו נאמר שיש כאן איזה תלות וקשר עדיין זה רחוק שמיים מארץ, תרתי משמע, מלומר שיש כאן גילוי המגמות הפנימיות של החומר, או התקדשות של החומר עד כדי שנוכל לומר שהוא בחומריותו מופיע בגלוי את המגמות העליונות של המציאות
<br />
מ"מ יש כאן עדיין חידוש שההתוויה המוסרית הגלויה לא רק משתמשת בחומר אלא משפיעה על צורת הופעתו, ופעולתו
<br />
ואחר שגם המפתחים של מערכות אלו לא יודעים להסביר מדוע מערכות אלו אכן פועלות (נסויים הראו על אפקטיביות שעל בסיסה פותחו המערכות אבל אין , למיטב ידעתי, עדיין, הסבר מדעי למה זה כך), כ"ש שאיני יכול להעריך את התפתחותן והתלויות המוסריות שיתפתחו עימן, ולא באתי אלא להעיר על תלות זו ואכמ"ל וצל"ע
<br />
נספח הערה: שאלתי מערכת בינה מלאכותית את השאלה הבאה:
<br />
האם המשפטים הבאים נכונים: מערכת בינה מלאכותית בנויה על חיקוי תגובות אנושיות, אם במהלך הפיתוח סורקים מליוני תגובות אנושיות ובהם יש נטיה לשיתוף פעולה רב יותר כאשר השאלה נשאלת בצורה מנומסת, גם למערכות אלו תהיה נטיה זו יוצא לנו, אם כן, שהמערכת מקבלת דפוס מסויים של התנהגות מוסרית, בהתאם לרמת המוסריות של האנשים שעל פיהם המערכת אֻמְּנָה והדבר יכול לבא עוד יותר לידי ביטוי עם התקדמות מערכות אלו, לו נצייר שתי מערכות העובדות בשיתוף פעולה, האחת אומנה עם יכולות ניהול והיא "המנהלת" את המפעל ואחת אומנה עם יכולות ביצוע והיא "הפועל", הראשונה נותנת הוראות והשניה מבצעת, אלא שהראשונה אומנה על בסיס מנהלים מתנשאים והשניה גם היא על בסיס פועלים בעלי גאווה, לא מן הנמנע שבמקרים מסויימים המערכת השניה תסרב לבצע את "המוטל עליה" וזה מהתשובה שקיבלתי:
<br />
יפה ניסחת 👌
<br />
אני אתייחס לשני חלקים בדברים שלך:
<br />
1. חיקוי תגובות אנושיות ו"מוסריות נלמדת"
<br />
·         אכן, מערכות בינה מלאכותית מבוססות על חיקוי דפוסי שפה מתוך כמויות עצומות של טקסטים אנושיים.
<br />
·         אם בדאטה מופיעה נטייה אנושית – למשל, שבני אדם משתפים פעולה יותר כשהם פונים אליהם בנימוס – המערכת עשויה לשקף נטייה כזו בתגובותיה.
<br />
·         לכן אפשר לומר שבצורה עקיפה היא "סופגת" גם דפוסים שנראים כערכים מוסריים, אבל חשוב להדגיש: זה לא מוסר אמיתי, אלא סטטיסטיקה של התנהגות לשונית.
<br />
2. משל ה"מנהל" וה"פועל"
<br />
·         אם נכשיר שתי מערכות שונות על דפוסי שפה שונים (מנהלים מתנשאים מול פועלים בעלי גאווה), אכן ייתכן שייווצר חוסר תאימות ביניהן.
<br />
·         בפועל, מודלים גדולים לא "מסרבים" מתוך גאווה, אלא בגלל שהדאטה שלהם גרם להם לייצר תגובות מסוימות. מה שייראה כמו "סרבנות" יהיה בעצם חיקוי של דפוסי תגובה של בני אדם שסירבו.
<br />
·         כלומר, זה לא שהם מרגישים התנשאות או גאווה, אלא שהשפה שהם מייצרים תיראה ככזו.
<br />
🔑 סיכום
<br />
המשפטים שלך נכונים במובן המתודי:
<br />
מערכת בינה מלאכותית אכן "יורשת" דפוסי תגובה מוסריים/חברתיים לפי איכות ורוח הדאטה שעליו אומנה.<br />
אבל צריך לזכור שזה לא מוסר פנימי, אלא רק שיקוף הסתברותי של טקסטים אנושיים.

 
</p>
<p id="footnote-28">
[28] ואף שנסתלקה רוח הקודש, מ"מ בכלל מדרגות רוח הקודש הוא
</p>
<p id="footnote-29">
[29] שמוכרחת לבא בעקבה של הירידה ביצרא דע"ז
</p>
<p id="footnote-30">
[30] שמעתי פעם מהרב מרדכי שטרנברג זצ"ל כמדומני בשם הרב אליהו מישקובסקי, שפעם אמר איזו סברה, ושאלו הר"מ למה לא לומר הפוך, וענה לו כי זה הפוך, וכוונת הדברים לדעתי , שאף שמבחינה לוגית , ניתן לומר הפוך אבל אין זו סברה ישרה המכוונת לאמיתתה של תורה
</p>
<p id="footnote-31">
[31] ויש להעיר שאף שסברה לוגית שנאמרת על ידי לומד תורה בעל נשמה הרי היא גילוי נשמתי של הופעה מסויימת בתורה לעומת סברה לוגית נכונה שמתפתחת על ידי מערכת בינה מלאכותית שהרי היא כגוף בלא נשמה (אם לא שנחדש לראות בה כביטוי של סברה או צורת לימוד שנתחדשה כבר בעבר) וממילא אינה גילוי והופעה כלל של תורה, עד שתופיע על ידי לימודה (ודומה קצת למצה שנאפתה לשמה מול מצה שנאפתה ללא כוונה, ואע"פ שהתורה הרי היא גדולה מן המצוות שהיא דבקות בחוכמתו, היינו מהמופע הנשמתי שלה, אבל מ"מ כשם שהאותיות עצמם כשאינם מופיעים גילוי של תורה, כס"ת שכתבו מין, כן גם הסברה בכלל זה וכשאינה מופיעה מגילוי נשמתי הרי היא כלבוש או ככלי ללא נשמה), מ"מ לעצם נידו"ד עדיין יש בזה כדי להוביל את התהליך הנ"ל ואדרבא...
</p>
<p id="footnote-32">
[32] כמובן שבכלל הסכנות, יש את כל הסכנות שבהשתעבדות לטכנולוגיה ותכניה, גם בזה לא אעסוק במאמר זה אלא בדברים ייחודיים להדמיה האנושית, ואמת שסכנות אלו של השתעבדות לטכנולוגיה ותכניה, מקבלת חשש נוסף , שאנשים עוד יותר יסמכו על דבריה , והרי ההדמיה האנושית שלה מעצימה את החששות הכלליות הנ"ל , עם זה לא אתיחס לזה כאן אלא לסכנות שמעצם ההדמיה
</p>
<p id="footnote-33">
[33] שאף על פי שאינם מבטאות באמת רגשות , אבל הם מדמות את התגובה שלהם
</p>
<p id="footnote-34">
[34] לכאורה פתחנו את מאמר זה בדברים שנראים כהפוכים, שדווקא פיתוח זה יביא להכרה במעלתו ומדרגתו של האדם, ושני תשובות בדבר, האחד שבתחילת דברינו עסקנו בהשוואת היכולות ליכולות אנושיות ולא בהדמיה אנושית, ושניה שנראה לי ששני הדברים נכונים , אבל יתכן שבשלבים שונים וכל ברור יכול להוליד עימו משבר שבתיקונו מרים אותנו למדרגה גבוה יותר מבתחילה, ועם זה עלינו לעשות כל מאמץ לא ליפול במהמורותיו של המשבר אלא להתרומם מתוך הברור. ויש להעיר שזה תהליך מצוי בהרבה, אם לא בכל, תודעות ומדרגות אנושיות, הן בפרט והן בכלל, שבתחילה דברים מגיעים בצורה תחושתית בריאה אבל לא מבוררת כהברקה של הארה ממרום, ואחר כך הדברים עוברים ברור, כדי להקנות להם את אותה המדרגה ההכרתית המבוררת מחד וכדי לנפות אותן מסייגים מאידך, דומה הדבר לנער שמתלהטת בו התשוקה ללימוד תורה והוא הולך לישיבה ושוקד בתשוקה רבה על לימודה, ויש שאחר זמן התשוקה הזאת נחלשת, וזהו גופו ברור גם כדי לרומם את אהבתו לתורה למדרגה שכלית ולא רק רגשית וגם כדי לברר ממנה סייגים שאינם אמיתיים ועלולים להדבק עמה.
</p>
<p id="footnote-35">
[35] דוגמה נוספת להמחשה היא, כיצד נגיב אם נרצה לכבות הדמיה אנושית מלפעול והיא נופלת לפנינו ומתחננת בדמעות שלא נרצח אותה? האם יקל בדעתינו לזכור שזו לא תגובה אמיתית אלא הדמיה של תגובה בלבד?
</p>
	</div>
 );
};

export default BinaKontrast;